import React, { useEffect, useRef, useState, useReducer, useMemo, useCallback } from "react";
import {
	fetchWalletBalance,
	getAuthMobile,
	getLocalStorageMenuItem,
	SARIconThemeColor,
	sendNotificationFirebaseRes,
	setLocalStorageMenuItem,
	setMobileBackColor,
	setMobileButttonBackColor,
	setMobileCardBorderColor,
	setMobileCardColor,
	setMobileHighlightTextColor,
	setMobileTextColor,
} from "../utility";
import { Container, Navbar } from "react-bootstrap";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import coverSample from "../images/No_Image_Available.jpg";
import no_image from "../images/No_Image_Available.jpg";
import axios from "axios";
import Toast from "../common/toast";
import { useMutation, useQuery, useQueryClient } from "react-query";
import "../css/mobileScreens.css";
import Loading from "../common/loading";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
	Button, CircularProgress, MenuItem, TextField,
	Select, Dialog, DialogActions, DialogContent, DialogTitle,
	FormControl, InputLabel, Box, Slide, Badge, Typography, InputAdornment,
	FormControlLabel,
	Checkbox,
	Radio, // Add this
	RadioGroup, // Add this
	FormLabel, // Add this
} from "@mui/material";
import {
	ApartmentOutlined, ArrowBackOutlined, ArrowForwardOutlined, Delete, DeleteOutline, DescriptionOutlined,
	EditLocationAltOutlined, FlagOutlined, HomeOutlined, HouseOutlined,
	LocalOfferOutlined,
	LocalPostOffice, LocalPostOfficeOutlined, LocalShippingOutlined,
	LocationCity, LocationOnOutlined, PinDropOutlined, StairsOutlined,
	Title, TitleOutlined,
	Edit, Restaurant, LocalDining, LocalShipping
} from "@mui/icons-material";
import { Form, Formik } from "formik";
import Order from "../components/mobile screen/cart/order";
import { t } from "i18next";
import LoadingTreeDataDialog from "../components/mobile screen/mobileComponents/LoadingTreeDataDialog";
import stripe_image from "../images/stripe-payement-gateway-logos.png";
import urway_image from "../images/urway-payement-gateway-logos.png";
import BottomNavBar from "../components/BottomNavBar";
import LoginComponent from "../components/mobile screen/mobileComponents/loginComponent";
import DeliveryDialog from "../components/DeliveryDialog";
import CurrentLocationMap from "../components/map screens/CurrentLocationMap";
import NewLocationPicker from "../components/map screens/NewLocationPicker";
import { LoadingButton } from "@mui/lab";
import DeleteLocationDialog from "../components/DeleteLocationDialog";
import CurrentLocationDialog from "../components/map screens/CurrentLocationDialog";
import NewLocationDialog from "../components/map screens/NewLocationDialog";
import LocationFormDialog from "../components/map screens/LocationFormDialog";
import VenueToLocationMap from "../components/VenueToLocationMap";
import { m } from "framer-motion";
import LocationDistanceDialog from "../components/map screens/LocationDistanceDialog";


const useOrderType = (treeData, params) => {
	const storedOrderType = getLocalStorageMenuItem("orderType");

	const initialActiveType = () => {
		// If there's a table parameter and dine-in is active, force dine-in
		if (treeData?.details?.is_dinein_active && params.get("t") && params.get("t") !== "null") {
			return "dinein";
		}

		// Use stored order type if available and valid
		if (storedOrderType) {
			if (storedOrderType === "browse") {
				return "browse"; // Keep browse mode until user explicitly changes
			}

			if (
				(storedOrderType === "dinein" && treeData?.details?.is_dinein_active && params.get("t") && params.get("t") !== "null") ||
				(storedOrderType === "pickup" && treeData?.details?.is_pickup_active) ||
				(storedOrderType === "delivery" && treeData?.details?.is_delivery_active)
			) {
				return storedOrderType;
			}
		}

		// If no valid stored type, don't set a default - return "browse" instead
		return "browse";
	};

	const setActiveType = (type) => {
		setState(prev => ({
			isDineIn: type === "dinein",
			isPickup: type === "pickup",
			isDelivery: type === "delivery",
			activeType: type
		}));
		// Store the selected type in localStorage
		setLocalStorageMenuItem("orderType", type);
	};

	const initialState = {
		isDineIn: initialActiveType() === "dinein",
		isPickup: initialActiveType() === "pickup",
		isDelivery: initialActiveType() === "delivery",
		activeType: initialActiveType()
	};

	const [state, setState] = useState(initialState);

	return {
		...state,
		setActiveType
	};
};

// Custom hook for location management
const useLocationManagement = () => {
	const [mode, setMode] = useState(null);
	const [selectedPlace, setSelectedPlace] = useState(null);
	const [placeAddress, setPlaceAddress] = useState("");
	const [latLangVal, setLatLangVal] = useState(null);
	const [isEditDelivery, setIsEditDelivery] = useState(false);
	const [isProcessLoading, setIsProcessLoading] = useState(false);
	const [deleteLocationDialogOpen, setDeleteLocationDialogOpen] = useState(false);
	const [distanceBetween, setDistanceBetween] = useState(null);
	const [durationBetween, setDurationBetween] = useState(null);
	const [calcDeliveryFeesValue, setCalcDeliveryFeesValue] = useState(0);

	const initialLocationFormData = {
		title: "",
		street: "",
		unit_number: "",
		floor_number: "",
		apartment_number: "",
		description: "",
		latitude: "",
		longitude: "",
		suburb: "",
		city: "",
		province: "",
		state: "",
		postcode: "",
		country: ""
	};

	const [locationFormData, setLocationFormData] = useState(initialLocationFormData);

	const handleLocationFormInputChange = (e) => {
		setLocationFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
	};

	const resetLocationForm = () => {
		setLocationFormData(initialLocationFormData);
		setLatLangVal(null);
		setIsEditDelivery(false);
	};

	return {
		mode,
		setMode,
		selectedPlace,
		setSelectedPlace,
		placeAddress,
		setPlaceAddress,
		latLangVal,
		setLatLangVal,
		isEditDelivery,
		setIsEditDelivery,
		isProcessLoading,
		setIsProcessLoading,
		deleteLocationDialogOpen,
		setDeleteLocationDialogOpen,
		distanceBetween,
		setDistanceBetween,
		durationBetween,
		setDurationBetween,
		calcDeliveryFeesValue,
		setCalcDeliveryFeesValue,
		locationFormData,
		setLocationFormData,
		handleLocationFormInputChange,
		resetLocationForm
	};
};

// Custom hook for cart persistence
const useCartPersistence = (tableQr) => {
	const storageKey = `cartState_${tableQr}`;

	const saveCartState = (state) => {
		try {
			setLocalStorageMenuItem(storageKey, JSON.stringify(state));
		} catch (error) {
			console.error("Error saving cart state:", error);
		}
	};

	const loadCartState = () => {
		try {
			const savedState = getLocalStorageMenuItem(storageKey);
			return savedState ? savedState : null;
		} catch (error) {
			console.error("Error loading cart state:", error);
			return null;
		}
	};

	const clearCartState = () => {
		localStorage.removeItem(storageKey);
	};

	return { saveCartState, loadCartState, clearCartState };
};

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const Cart = ({ tableQr, tableName }) => {
	const [isTabLoading, setIsTabLoading] = useState(false);
	const queryClient = useQueryClient();
	const navigate = useNavigate();
	const location = useLocation();
	const [params, setParams] = useSearchParams();
	const queryString = window.location.search;
	const urlParam = new URLSearchParams(queryString);
	const divRef = useRef(null);
	const [divWidth, setDivWidth] = useState(null);
	const [orderNote, setOrderNote] = useState("");

	// State management
	const [loadingTree, setLoadingTree] = useState(false);
	const [loadingTreeDialog, setLoadingTreeDialog] = useState(false);
	const [openDialog, setOpenDialog] = useState(false);
	const [payment_method, setPaymentMethod] = useState("");
	const [payment_method_temp, setPaymentMethodTemp] = useState("");
	const [selectedGateway, setSelectedGateway] = useState("mada");
	const [gatewayImage, setGatewayImage] = useState(urway_image);
	const [toastSettings, setToastSettings] = useState({
		open: false,
		message: "",
		success: false,
	});
	const [timeZone, setTimeZone] = useState(getLocalStorageMenuItem("timezone") || "");
	const [formValues, setFormValues] = useState(null);
	const [formSubmitValues, setFormSubmitValues] = useState(null);
	const [isFromOrder, setIsFromOrder] = useState(false);

	const [allTreeData, setAllTreeData] = useState(() => {
		const savedTreeData = getLocalStorageMenuItem("tree_data");
		return savedTreeData ? savedTreeData : [];
	});

	const [confirmEmptyDialog, setConfirmEmptyDialog] = useState(false);
	const [useWallet, setUseWallet] = useState(false);
	const [customerBalance, setCustomerBalance] = useState(0);

	const [isLoadingDefaultAddress, setIsLoadingDefaultAddress] = useState(true);
	const [defaultAddress, setDefaultAddress] = useState(null);

	const [couponCode, setCouponCode] = useState("");
	const [appliedCoupon, setAppliedCoupon] = useState(null);
	const [couponLoading, setCouponLoading] = useState(false);

	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);
	const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
	const [locationDistanceDialogOpen, setLocationDistanceDialogOpen] = useState(false);
	const [isConfirmingOrder, setIsConfirmingOrder] = useState(false);
	const [orderTypeDialogOpen, setOrderTypeDialogOpen] = useState(false);
	const [openPaymobDialog, setOpenPaymobDialog] = useState(false);

	const getOrderTypeDisplayText = (type) => {
		switch (type) {
			case "dinein": return t("Dine In");
			case "pickup": return t("Pickup");
			case "delivery": return t("Delivery");
			case "browse": return t("Browsing mode");
			default: return type;
		}
	};

	const handleOrderTypeSelection = async (type, setFieldValue) => {
		try {
			setIsTabLoading(true);

			// Call the existing handleSelectedType function which contains all the logic
			await handleSelectedType(setFieldValue, type);

			// Update localStorage and close dialog
			setLocalStorageMenuItem("orderType", type);
			setOrderTypeDialogOpen(false);

		} catch (error) {
			console.error("Error switching order type:", error);
			handleOpenToast(t("Error switching order type"), false);
		} finally {
			setIsTabLoading(false);
		}
	};

	const FullScreenProgressDialog = ({ open }) => {
		return (
			<Dialog
				open={open}
				fullScreen
				PaperProps={{
					style: {
						backgroundColor: 'rgba(0, 0, 0, 0.5)',
						backdropFilter: 'blur(2px)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}
				}}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						padding: '20px',
						borderRadius: '16px',
						backgroundColor: setMobileCardColor(),
						boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
					}}
				>
					<CircularProgress
						size={60}
						thickness={4}
						style={{
							color: setMobileButttonBackColor(),
							marginBottom: '16px'
						}}
					/>
					<Typography
						className="head-font"
						style={{
							color: setMobileTextColor(),
							fontSize: '18px',
							fontWeight: 600,
							textAlign: 'center'
						}}
					>
						{t("Confirming your order...")}
					</Typography>
					<Typography
						className="sub-font"
						style={{
							color: setMobileTextColor(),
							fontSize: '14px',
							opacity: 0.8,
							textAlign: 'center',
							marginTop: '8px'
						}}
					>
						{t("Please wait while we confirm your order")}
					</Typography>
				</div>
			</Dialog>
		);
	};
	// Add this useEffect for responsive detection
	useEffect(() => {
		const handleResize = () => {
			const width = window.innerWidth;
			setIsMobile(width < 768);
			setIsTablet(width >= 768 && width < 1024);
			setIsDesktop(width >= 1024);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const applyCouponFunction = async (code) => {
		setCouponLoading(true);
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/apply-coupon`,
				{
					code: code,
					basket_order_id: basketData?.data?.data?.id || ""
				},
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${MobileToken}`,
					},
				}
			);
			return response.data;
		} catch (error) {
			throw error;
		} finally {
			setCouponLoading(false);
		}
	};

	const { mutate: mutateCoupon } = useMutation(applyCouponFunction, {
		onSuccess: (response) => {
			if (response.success) {
				setAppliedCoupon(response.data);
				setCouponCode("");
				handleOpenToast(response.message || t("Coupon applied successfully"), true);
				refetchBasket(); // Refresh basket data
			} else {
				handleOpenToast(response.message || t("Failed to apply coupon"), false);
			}
		},
		onError: (error) => {
			handleOpenToast(
				error.response?.data?.message || t("Failed to apply coupon"),
				false
			);
		},
	});

	const handleApplyCoupon = () => {
		if (!couponCode.trim()) {
			handleOpenToast(t("Please enter a coupon code"), false);
			return;
		}

		if (!MobileToken) {
			handleOpenToast(t("Please login to apply coupon"), false);
			handleOpenDialog(0);
			return;
		}

		mutateCoupon(couponCode.trim());
	};

	// Add this function to fetch the default address
	const fetchDefaultAddress = async () => {
		setIsLoadingDefaultAddress(true);
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_API}/customer/addresses/default`,
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${MobileToken}`,
					},
				}
			);

			if (response.data.data) {
				setDefaultAddress(response.data.data);
				// Set as selected place if no place is selected
				if (!selectedPlace) {
					setSelectedPlace(response.data.data);
					handleSelectPlace(response.data.data, 1)
					const addressParts = [
						`${t("LocationName")} ${response.data.data.title || 'NAN'}`,
						`${t("Street")} ${response.data.data.street || 'NAN'}`,
						`${t("Unit No")} ${response.data.data.unit_number || 'NAN'}`,
						`${t("Floor No")} ${response.data.data.floor_number || 'NAN'}`,
						`${t("Apartment No")} ${response.data.data.apartment_number || 'NAN'}`
					];
					setPlaceAddress(addressParts.join(", "));
				}

			}
		} catch (error) {
			setIsLoadingDefaultAddress(false);
			console.error("Error fetching default address:", error);
		} finally {
			setIsLoadingDefaultAddress(false);
		}
	};

	// Custom hooks
	const {
		isDineIn: isDineInFlag,
		isPickup: isPickupFlag,
		isDelivery: isDeliveryFlag,
		activeType,
		setActiveType
	} = useOrderType(allTreeData, params);


	const {
		mode,
		setMode,
		selectedPlace,
		setSelectedPlace,
		placeAddress,
		setPlaceAddress,
		latLangVal,
		setLatLangVal,
		isEditDelivery,
		setIsEditDelivery,
		isProcessLoading,
		setIsProcessLoading,
		deleteLocationDialogOpen,
		setDeleteLocationDialogOpen,
		distanceBetween,
		setDistanceBetween,
		durationBetween,
		setDurationBetween,
		calcDeliveryFeesValue,
		setCalcDeliveryFeesValue,
		locationFormData,
		setLocationFormData,
		handleLocationFormInputChange,
		resetLocationForm
	} = useLocationManagement();

	const { saveCartState, loadCartState, clearCartState } = useCartPersistence(tableQr);

	const MobileToken = getLocalStorageMenuItem("mobileLoginToken");
	const lang = getLocalStorageMenuItem("lang");
	const check_login = MobileToken || null;
	const [deliveryDialogOpen, setDeliveryDialogOpen] = useState(false);
	const [openLocationFormDialog, setOpenLocationFormDialog] = useState(false);

	// Memoized values
	const currencySymbol = useMemo(() => allTreeData?.details?.currency_symbol || "", [allTreeData]);
	const isSA = useMemo(() => timeZone === "SA", [timeZone]);

	const [dialogOpen, setDialogOpen] = useState(false);
	// API calls
	const getTimeZone = async () => {
		try {
			const response = await axios.get(`${process.env.REACT_APP_API}/timezone`);
			if (response.status === 200) {
				const timezoneData = response?.data?.data?.timezone || "";
				setLocalStorageMenuItem("countryCode", JSON.stringify(response?.data?.data?.countryCode));
				setLocalStorageMenuItem("timezone", JSON.stringify(timezoneData));
				setTimeZone(response?.data?.data?.countryCode);
			}
		} catch (error) {
			console.error("Error fetching timezone:", error);
		}
	};


	const loadTree = async () => {
		setLoadingTree(true);
		try {
			const timeZone = getLocalStorageMenuItem("timezone") || "";
			const response = await axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-tree?table=${params.get('t') || null}`,
				{
					headers: {
						localization: getLocalStorageMenuItem("lang") || "",
						timeZone: timeZone.replace(/["]+/g, ''),
					},
				}
			);

			if (!response?.data?.data?.details || !response?.data?.data?.tree || !response?.data?.data?.items) {
				setLoadingTreeDialog(true);
			}

			const treeData = response?.data?.data || [];
			setAllTreeData(treeData);
			setLocalStorageMenuItem("tree_data", JSON.stringify(treeData));
			return treeData;
		} catch (error) {
			console.error("Error loading tree:", error);
			handleOpenToast(t("Error loading menu data"), false);
		} finally {
			setLoadingTree(false);
		}
	};

	const loadTreeData = async () => {
		if (allTreeData.length === 0 || !allTreeData.details || !allTreeData.tree || !allTreeData.items) {
			await loadTree();
		} else {
			const pathSegments = location.pathname.split('/');
			const menu_code_number = pathSegments[2];
			const treeMenu_code_number = allTreeData?.details?.code_number;
			if (menu_code_number !== treeMenu_code_number) {
				await loadTree();
			}
		}
	};

	const getPaymobPaymentIntention = async (amount) => {
		const res = await axios.post(
			`${process.env.REACT_APP_API}/payment-intention`,
			{ amount },
			{
				headers: {
					Authorization: `Bearer ${MobileToken}`,
					"Content-Type": "application/json",
				},
			}
		);

		return res.data.data; // { public_key, client_secret }
	};

	const initPaymobPixel = ({ public_key, client_secret }) => {
		if (!window.Pixel) {
			console.error("Paymob Pixel SDK not loaded");
			return;
		}

		const container = document.getElementById("paymob-pixel-container");
		if (container) container.innerHTML = "";

		new window.Pixel({
			publicKey: public_key,
			clientSecret: client_secret,
			elementId: "paymob-pixel-container",

			paymentMethods: ["card"],
			locale: lang || "en",

			onSuccess: () => {
				// 🔥 CALL YOUR EXISTING SUCCESS LOGIC
				handlePayment();
				setOpenPaymobDialog(false);
			},

			onFailure: () => {
				setIsConfirmingOrder(false);
				setOpenPaymobDialog(false);
			},

			onCancel: () => {
				setIsConfirmingOrder(false);
				setOpenPaymobDialog(false);
			},
		});
	};


	const {
		data: basketData,
		isLoading: basketIsLoading,
		isFetching: basketIsFetching,
		refetch: refetchBasket
	} = useQuery(
		["basket-items", getLocalStorageMenuItem("lang"), activeType, selectedPlace?.id, distanceBetween],
		async () => {
			const response = await axios.get(
				`${process.env.REACT_APP_API}/basket-items?menu_code=${tableQr}&token=${getLocalStorageMenuItem("gustToken")}&distance=${distanceBetween || ""}&address_id=${selectedPlace?.id || ""}&order_type=${activeType || ""}`,
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${MobileToken}`,
						localization: getLocalStorageMenuItem("lang") || "",
					},
				}
			);

			if (response?.data?.data?.length == 0) {
				handleOpenToast(t("Your Cart is empty"), false);
				navigate(
					`/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get("t")}&lang=${lang}`,
					{ replace: true }
				);
			}

			if (response?.data?.data?.discount_data) {
				setAppliedCoupon(response?.data?.data?.discount_data?.data);
			}

			return response;
		},
		{
			// Prevent unnecessary refetches
			refetchOnWindowFocus: false,
			refetchOnMount: true,
			staleTime: 1000 * 60 * 5, // 5 minutes
			cacheTime: 1000 * 60 * 10, // 10 minutes
		}
	);



	const {
		data: savedPlaces,
		isLoading: isLoadingSavedPlaces,
		refetch: refetchSavedPlaces
	} = useQuery(
		["saved-places"],
		async () => {
			const response = await axios.get(
				`${process.env.REACT_APP_API}/customer/addresses`,
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${MobileToken}`,
					},
				}
			);
			return response.data.data;
		},
		{
			enabled: !!MobileToken,
			refetchOnWindowFocus: false,
			retry: 1,
		}
	);


	const handleSaveLocation = async () => {
		setIsProcessLoading(true);
		const newPlace = {
			...locationFormData,
			latitude: latLangVal?.lat + "",
			longitude: latLangVal?.lng + "",
		};

		const token = getLocalStorageMenuItem("mobileLoginToken");

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/customer/addresses`,
				newPlace,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (response.status === 200 || response.status === 201) {
				setMode(null);
				handleOpenToast(t("Location has been added successfully"), true);
				handleCloseFormDialog();
				setLocationFormData({
					title: "",
					street: "",
					unit_number: "",
					floor_number: "",
					apartment_number: "",
					description: "",
					longitude: "",
					latitude: "",
					suburb: "",
					city: "",
					province: "",
					state: "",
					postcode: "",
					country: "",
					description: "",
					additional_notes: ""
				});
				refetchSavedPlaces();
				setLatLangVal(null);
				setIsEditDelivery(false);
			}
		} catch (error) {
			alert("Error saving location:", error);
			console.error("Error saving location:", error);
		} finally {
			setIsProcessLoading(false);
		}
	};

	const handleUpdateLocation = async () => {
		setIsProcessLoading(true);
		const token = getLocalStorageMenuItem("mobileLoginToken");
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/customer/addresses/${locationFormData.id}`,
				locationFormData,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (response.status === 200 || response.status === 201) {
				setMode(null);
				handleOpenToast(t("Location has been updated successfully"), true);
				handleCloseFormDialog();
				setLocationFormData({
					title: "",
					street: "",
					unit_number: "",
					floor_number: "",
					apartment_number: "",
					description: "",
					longitude: "",
					latitude: "",
					suburb: "",
					city: "",
					province: "",
					state: "",
					postcode: "",
					country: "",
					description: "",
					additional_notes: ""
				});
				refetchSavedPlaces();
				setLatLangVal(null);
				setIsEditDelivery(false);
			}
		} catch (error) {
			alert("Error updating location:", error);
			console.error("Error updating location:", error);
		} finally {
			setIsProcessLoading(false);
		}
	};

	const handleDeleteLocation = async () => {
		setIsProcessLoading(true);
		const token = getLocalStorageMenuItem("mobileLoginToken");
		try {
			const response = await axios.delete(
				`${process.env.REACT_APP_API}/customer/addresses/${selectedPlace.id}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);


			if (response?.status === 200 || response?.status === 201) {
				if (response?.data?.success) {
					setMode(null);
					handleOpenToast(t("Location has been deleted successfully"), true);
					setLocationFormData({
						title: "",
						street: "",
						unit_number: "",
						floor_number: "",
						apartment_number: "",
						description: "",
						longitude: "",
						latitude: "",
						suburb: "",
						city: "",
						province: "",
						state: "",
						postcode: "",
						country: "",
						description: "",
						additional_notes: ""
					});
					refetchSavedPlaces();
					setDeleteLocationDialogOpen(false);

					setLatLangVal(null);
					setIsEditDelivery(false);
				} else {
					handleOpenToast(
						<div className="alignByLang">
							{t(`${response?.data?.message}`)}
						</div>
						, false);
				}

			}
		} catch (error) {
			handleOpenToast(
				<div className="alignByLang">
					{t("Error deleting location:") + " " + error.message}
				</div>
				, false);
		} finally {
			setIsProcessLoading(false);
		}
	};





	const paymentFunction = async (token) => {

		const baseUrl = window.location.origin;

		const headers = {
			Authorization: `Bearer ${token ? token : getLocalStorageMenuItem("mobileLoginToken")}`,
			'Content-Type': 'application/json',
			localization: getLocalStorageMenuItem("lang") || "",
			timeZone: timeZone.replace(/["]+/g, ''),
		};


		const paymentParameters = {
			table: params.get("t") || null,
			token: getLocalStorageMenuItem("gustToken") || null,
			amount: useWallet ?
				Number(basketData?.data?.data?.the_final_total?.replace(/,/g, "")) - customerBalance :
				Number(basketData?.data?.data?.the_final_total?.replace(/,/g, ""))
			,
			gateway: selectedGateway,
			notes: formValues?.note || "",
			address: formValues?.address || "",
			address_id: selectedPlace?.id || null,
			menu_code: tableQr || "",
			type: formValues?.type || activeType,
			distance: distanceBetween || 0,
			duration: durationBetween || 0,
			delivery_fees: (formValues?.type === "delivery" || activeType === "delivery") ? Number(basketData?.data?.data?.the_delivery_amount || 0) + Number(basketData?.data?.data?.the_delivery_tax || 0) - Number(basketData?.data?.data?.the_delivery_discount || 0) : 0,
			payment_method: useWallet ? formValues?.payment_method_temp : formValues?.payment_method_temp,
			wallet_amount: useWallet ? customerBalance : 0,
			app_url: baseUrl || ""
		};

		const { data: response } = await axios.post(
			payment_method === "ONL" ?
				`${process.env.REACT_APP_API}/orders-payment` :
				`${process.env.REACT_APP_API}/orders`,
			paymentParameters,
			{ headers }
		);
		return response;
	};

	const { mutate: mutatePayment, isLoading: isLoadingMutatePayment } = useMutation(paymentFunction, {
		onSuccess: async (res) => {
			setLocalStorageMenuItem("amount", basketData?.data?.data?.the_final_total);
			setLocalStorageMenuItem("currency", currencySymbol || "");
			// params.set("payment_url", res?.data?.payment_url);
			setParams(params);
			if (useWallet) {
				const newBalance = await fetchWalletBalance();
				setCustomerBalance(newBalance);
			}
			setIsConfirmingOrder(false);
			// window.open(res.data.payment_url, "_self");
		},
		onError: async (error) => {
			try {
				handleOpenToast(t(error.response?.data?.message || "Error processing order"), false);
			} catch (error) {
				handleOpenToast(t("Error While Saving The Changes"), false);
			}
			setIsConfirmingOrder(false);
		},
		onSettled: () => {
			queryClient.invalidateQueries("clientMobilePayment");
		},
	});


	const addItemFunction = async (values, token) => {

		const onlineActive = allTreeData?.details?.is_online_payment_active;
		const cashActive = allTreeData?.details?.is_cash_payment_active;
		if (useWallet) {
			if (payment_method === "ONL" && values.payment_method_temp === "mix") {
				setFormValues(values);
				setFormSubmitValues(values);
				// openPaymentDialog();
				await handlePayment(token);
				return "online";
			}

		} else {
			if (values.payment_method_temp === "online" && onlineActive) {
				setFormValues(values);
				setFormSubmitValues(values);
				// openPaymentDialog();
				await handlePayment(token);
				return "online";
			}
		}


		const headers = {
			Authorization: `Bearer ${token ? token : getLocalStorageMenuItem("mobileLoginToken")}`,
			'Content-Type': 'application/json',
			localization: getLocalStorageMenuItem("lang") || "",
			timeZone: timeZone.replace(/["]+/g, ''),
		};

		const paymentParameters = {
			notes: values.note,
			address: values.address,
			menu_code: tableQr,
			token: getLocalStorageMenuItem("gustToken") || null,
			table: params.get("t"),
			address_id: selectedPlace?.id || null,
			pickup_venue: values.pickup_venue || "",
			type: values.type || activeType,
			distance: distanceBetween || 0,
			duration: durationBetween || 0,
			delivery_fees: (values.type === "delivery" || activeType === "delivery") ? Number(basketData?.data?.data?.the_delivery_amount || 0) + Number(basketData?.data?.data?.the_delivery_tax || 0) - Number(basketData?.data?.data?.the_delivery_discount || 0) : 0,
			payment_method: useWallet ? values.payment_method_temp : null,
			wallet_amount: useWallet ? customerBalance : 0
		};

		const response = await axios.post(
			`${process.env.REACT_APP_API}/orders`,
			paymentParameters,
			{ headers }
		);
		return response.data;
	};

	const { mutate: muteOrder, isLoading: isLoadingOrder } = useMutation(addItemFunction, {
		onSuccess: async (res) => {

			if (res !== "online") {
				await sendNotificationFirebaseRes(allTreeData?.details, "New Order", "New order has been created", "orders");
				await clearCartState();
				handleOpenToast(t("Order has been added successfully"), true);

				setTimeout(() => {
					handleBack();
					setIsConfirmingOrder(false);
				}, 1000);

				// Clear saved state after successful order

				if (useWallet) {
					const newBalance = await fetchWalletBalance();
					setCustomerBalance(newBalance);
				}
			} else {
				setIsConfirmingOrder(false);
			}
		},
		onError: (error) => {
			handleOpenToast(t(error.response?.data?.message || "Error processing order"), false);
			setIsConfirmingOrder(false);
		},
		onSettled: () => {
			queryClient.invalidateQueries("addOrder");
		},
	});

	const emptyOrderBasket = async () => {
		const { data: response } = await axios.post(
			`${process.env.REACT_APP_API}/empty-basket`,
			{
				menu_code: tableQr,
				token: getLocalStorageMenuItem("gustToken"),
			}
		);
		return response.data;
	};

	// Helper functions
	const handleGatewaySelect = (event) => {
		const gateway = event.target.value;
		setSelectedGateway(gateway);
		setGatewayImage(gateway === "stripe" ? stripe_image : urway_image);
	};

	const handleSelectedType = useCallback(async (handleOrderTypeField, orderType) => {
		setIsTabLoading(true);

		try {
			setActiveType(orderType);
			handleOrderTypeField("type", orderType);

			// Only proceed with specific logic if not in browse mode
			if (orderType !== "browse") {
				if (orderType === "pickup" && allTreeData?.details?.pickup_venues?.length === 1) {
					handleOrderTypeField("pickupVenue", allTreeData.details.pickup_venues[0].id);
				} else if (orderType === "delivery") {
					if (!check_login) {
						handleOpenDialog(0);
					} else {
						if (!selectedPlace) {
							setDeliveryDialogOpen(true);
						} else {
							// Check the distance of the selected place
							await handleSelectPlace(selectedPlace, 0);
						}
					}
				}
			}

			// Wait for the query to complete
			await refetchBasket();
		} catch (error) {
			console.error("Error switching tabs:", error);
			handleOpenToast(t("Error switching order type"), false);
		} finally {
			setIsTabLoading(false);
		}
	}, [allTreeData, check_login, setActiveType, refetchBasket]);

	const handleOptionSelect = (option) => {
		setMode(option);
	};

	const updateLocationFormData = (pickupMapAddress) => {
		setLocationFormData(prev => ({
			...prev,
			unit_number: pickupMapAddress?.house_number || "",
			street: pickupMapAddress?.road || "",
			suburb: pickupMapAddress?.suburb || pickupMapAddress?.neighbourhood || "",
			city: pickupMapAddress?.city || pickupMapAddress?.town || pickupMapAddress?.village || "",
			province: pickupMapAddress?.state || "",
			state: pickupMapAddress?.state || "",
			postcode: pickupMapAddress?.postcode || "",
			country: pickupMapAddress?.country || "",
			description: [
				pickupMapAddress?.road && `${t("Street")}: ${pickupMapAddress?.road}`,
				pickupMapAddress?.house_number && `${t("House Number")}: ${pickupMapAddress?.house_number}`,
				pickupMapAddress?.postcode && `${t("Postal Code")}: ${pickupMapAddress?.postcode}`,
				(pickupMapAddress?.city || pickupMapAddress?.town) &&
				`${t("City")}: ${pickupMapAddress?.city || pickupMapAddress?.town}`,
				pickupMapAddress?.country && `${t("Country")}: ${pickupMapAddress?.country}`
			]
				.filter(Boolean)
				.join(', '),
			additional_notes: ""
		}));
	};

	const getDistanceAndDuration = async (start, end) => {
		try {
			if (!start?.lng || !start.lat) {
				return 'no_start';
			}
			const url = `https://router.project-osrm.org/route/v1/driving/${start.lng},${start.lat};${end.lng},${end.lat}?overview=false`;
			const response = await axios.get(url);
			const data = response.data;

			const distanceInMeters = data.routes[0].distance;
			const durationInSeconds = data.routes[0].duration;

			return {
				distanceInMeters,
				durationInSeconds
			};
		} catch (error) {
			console.error('Error fetching distance and duration:', error);
			return null;
		}
	};

	const handleLocationDistanceConfirm = () => {
		setActiveType("pickup");
		setLocationDistanceDialogOpen(false);
		setSelectedPlace(null);
		setPlaceAddress("");
		setDeliveryDialogOpen(false);
		refetchBasket();
	};

	const handleLocationDistanceCancel = () => {
		setLocationDistanceDialogOpen(false);

	};

	const handleSelectPlace = async (place, is_edit) => {
		if (params.get("t") && params.get("t") !== "null") {
			return true;
		}

		const venue_latitude = allTreeData?.details?.venue_latitude || 0;
		const venue_longitude = allTreeData?.details?.venue_longitude || 0;
		const selectedPlace_latitude = place?.latitude || 0;
		const selectedPlace_longitude = place?.longitude || 0;

		const distanceAndDuration = await getDistanceAndDuration(
			{ lat: venue_latitude, lng: venue_longitude },
			{ lat: selectedPlace_latitude, lng: selectedPlace_longitude }
		);

		if (distanceAndDuration === 'no_start') {
			const distanceInKm = 0;
			const durationInMinutes = 0;
			await calcDeliveryFees(distanceInKm);
			setDistanceBetween(distanceInKm);
			setDurationBetween(durationInMinutes);
			setSelectedPlace({ ...place, distance: distanceInKm, duration: durationInMinutes });
		} else {
			if (distanceAndDuration) {
				const { distanceInMeters, durationInSeconds } = distanceAndDuration;
				const distanceInKm = (distanceInMeters / 1000).toFixed(2);
				const durationInMinutes = (durationInSeconds / 60).toFixed(2);

				if (distanceInKm > 20) {
					// handleOpenToast(t("Selected location is too far (more than 20km). Please choose a closer location."), false);
					setLocationDistanceDialogOpen(true);
					return;
				}

				await calcDeliveryFees(distanceInKm);
				setDistanceBetween(distanceInKm);
				setDurationBetween(durationInMinutes);
				setSelectedPlace({ ...place, distance: distanceInKm, duration: durationInMinutes });

				// Use refetchBasket instead of refetchBasketItemsData
				refetchBasket();
			} else {
				handleOpenToast(t("Error while specifying the location"), false);
				return;
			}
		}

		setLocationFormData(place || {});
		setIsEditDelivery(is_edit);

		const addressParts = [
			`${t("LocationName")} ${place.title || 'NAN'}`,
			`${t("Street")} ${place.street || 'NAN'}`,
			`${t("Unit No")} ${place.unit_number || 'NAN'}`,
			`${t("Floor No")} ${place.floor_number || 'NAN'}`,
			`${t("Apartment No")} ${place.apartment_number || 'NAN'}`
		];

		setPlaceAddress(addressParts.join(", "));

		if (!is_edit) {
			resetLocationForm();
			setDeliveryDialogOpen(false);
		}
	};

	const calcDeliveryFees = (distance) => {
		const response = axios.post(
			`${process.env.REACT_APP_API}/calculate-delivery-fees`,
			{
				basket_order_id: basketData?.data?.data?.id || "",
				token: getLocalStorageMenuItem("gustToken") || null,
				distance: distance || 0,
				order_type: "delivery",
				menu_code: tableQr || ""
			},
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${MobileToken}`,
				},
			}
		).then((response) => {
			if (response.data.success) {
				const fees = response.data.data.delivery_fees || 0;
				setCalcDeliveryFeesValue(fees);
			}
		}).catch((error) => {
			console.error("Error calculating delivery fees:", error);
			setCalcDeliveryFeesValue(0);
		});

		return response;

	};

	const refetchBasketItemsData = async (orderType, s_place, distance) => {
		await axios.get(
			`${process.env.REACT_APP_API}/basket-items?menu_code=${tableQr}&token=${getLocalStorageMenuItem("gustToken")}&distance=${distance || ""}&address_id=${s_place?.id || ""}&order_type=${orderType || ""}`,
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${MobileToken}`,
				},
			}
		).then((response) => {
			if (response?.data?.data?.discount_data) {
				setAppliedCoupon(response?.data?.data?.discount_data?.data);
			}

			return response;
		}).catch((error) => {
			console.error("Error refetching basket items:", error);
			return null;
		});
	}

	const handleOpenDeleteLocationDialog = (place) => {
		setDeleteLocationDialogOpen(true);
		setSelectedPlace(place);
	};

	const handleCloseFormDialog = () => {
		setOpenLocationFormDialog(false);
		// resetLocationForm();
	};

	const openPaymentDialog = () => {
		setOpenDialog(true);
	};

	const closePaymentDialog = () => {
		setOpenDialog(false);
	};

	const handleOrderPayment = (values, token) => {
		muteOrder(values, token);
	}

	const handlePayment = (token) => {
		mutatePayment(token);
		setOpenDialog(false);
	};

	const handleOpenDialog = (is_from_order) => {
		setIsFromOrder(is_from_order);
		setDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setDialogOpen(false);
	};

	const handleVerificationSuccess = (token) => {

		const onlineActive = allTreeData?.details?.is_online_payment_active;

		if (token) {
			if (isFromOrder && formSubmitValues) {
				if (allTreeData?.details?.order_ability) {
					if (payment_method === "ONL" && onlineActive) {
						handlePayment(token);
					} else {
						handleOrderPayment(formSubmitValues, token);
					}
				} else {
					sendToWhatsApp(formSubmitValues, allTreeData?.details?.whatsapp);
				}

			} else {
				setDeliveryDialogOpen(true);
			}
		}


	};

	const handleBack = () => {
		// Save cart state before navigating away
		if (basketData?.data?.data) {
			saveCartState({
				orderType: activeType,
				payment_method,
				selectedGateway,
				selectedPlace,
				placeAddress,
				// orderNote,
				distanceBetween,
				durationBetween,
				basketData: basketData.data.data,
				formValues: formValues || {},
			});
		}

		if (urlParam.get("section")) {
			navigate(
				`/${tableName}/${tableQr}/sections?section=${urlParam.get("section")}&t=${urlParam.get("t")}&lang=${lang}`
				, {
					replace: true
				});
		} else {
			navigate(
				`/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get("t")}&lang=${lang}`
				, {
					replace: true
				});
		}
	};

	const handleSaveCartState = () => {
		if (basketData?.data?.data) {
			saveCartState({
				orderType: activeType,
				payment_method,
				selectedGateway,
				selectedPlace,
				placeAddress,
				orderNote,
				distanceBetween,
				durationBetween,
				basketData: basketData.data.data,
				formValues: formValues || {},
			});

		}
	}



	const onImageError = (e) => {
		e.target.src = coverSample;
	};

	const handleOpenToast = (message, state) => {
		setToastSettings({
			open: true,
			success: state,
			message: message
		});
	};

	const handleCloseToast = (event, reason) => {
		if (reason === "clickaway") return;
		setToastSettings({ open: false, message: "", success: false });
	};

	const sendToWhatsApp = (values, whatsapp_no) => {
		let message = `*${t("Order details")}:*\n`;
		message += `-----------------------\n\n`;

		// Order type information
		const orderType = values.type ||
			(allTreeData?.details?.is_dinein_active ? "dinein" :
				allTreeData?.details?.is_pickup_active ? "pickup" :
					allTreeData?.details?.is_delivery_active ? "delivery" : "");

		if (orderType) {
			message += `*${t("Type")} :* ${t(orderType)}\n`;

			if (orderType === "pickup") {
				const pickVenueItem = allTreeData?.details?.pickup_venues?.find(vitem => vitem.id === values.pickupVenue)?.name ||
					allTreeData?.details?.pickup_venues[0]?.name || "";
				message += values.pickupVenue ? `*${t("Pickup Venue")} :* ${t(pickVenueItem) || ""}\n` : "";
			}
		}

		// Address information
		message += values.address ? `*${t("Address")}:* ${values.address || ""}\n` : "";
		if (isDineInFlag) {
			message += values.table ? `*${t("Table")}:* ${values.table || ""}\n` : "";
		}

		// Items list
		message += `\n*${t("items")}:*\n`;
		values.items.forEach((item) => {
			message += `-${t(item?.name)} X ${item.quantity} X ${item.price} ${currencySymbol}\n`;
			if (item.notes) {
				message += `${item.notes || ""}\n`;
			}
			message += `\n`;
		});

		// Payment details
		message += `\n*${t("Payment details")}:*\n`;
		message += `${t("Subtotal")}: ${values.the_sub_total} ${currencySymbol}\n`;
		message += `${t("Tax")}: ${values.tax} ${currencySymbol}\n`;

		if (values?.tax_admin > 0) {
			message += `${t("Admin tax")}: ${values.tax_admin} ${currencySymbol}\n`;
		}

		if (isDeliveryFlag) {
			message += `${t("Payment Method")}: ${values.payment_method}\n`;
			message += `${t("Delivery Fees")}: ${values?.the_delivery_amount + values?.the_delivery_tax - values?.the_delivery_discount || 0} ${currencySymbol}\n`;
		}

		const finalTotal = Number(values.the_final_total?.replace(/,/g, ""));

		message += `${t("Total")}: ${finalTotal} ${currencySymbol}\n`;
		message += `*${t("Total plus VAT")}*\n\n\n`;

		if (values.note) {
			message += `*${t("Note")} :* ${values.note || ""}\n`;
		}

		handleOpenToast(t("Order has been sent successfully"), true);
		emptyOrderBasket();
		setTimeout(() => handleBack(), 1000);

		const whatsappUrl = `https://api.whatsapp.com/send?phone=${whatsapp_no}&text=${encodeURIComponent(message)}`;
		window.open(whatsappUrl, "_blank");
		handleBack();
	};



	const handleSubmit = async (values, { setErrors }) => {

		const currentOrderType = getLocalStorageMenuItem("orderType");
		if (!currentOrderType || currentOrderType === "browse") {
			handleOpenToast(t("Please select an order type first"), false);
			setOrderTypeDialogOpen(true);
			setIsConfirmingOrder(false);
			return;
		}
		setFormSubmitValues(values);
		setFormValues(values);
		setIsConfirmingOrder(true);
		try {
			if (MobileToken && MobileToken.length > 0) {

				if (!payment_method && !values.payment_method) {
					setErrors({ payment_method: t("Please select a payment method") });
					setIsConfirmingOrder(false);
					handleOpenToast(t("Please select a payment method"), false);
					return;
				}

				// Check for delivery order with no selected place
				if (isDeliveryFlag && !selectedPlace) {
					setIsConfirmingOrder(false);
					handleOpenToast(t("Please select a delivery address first"), false);
					setDeliveryDialogOpen(true);
					return;
				}

				// Check if distance is more than 20km for delivery
				if (isDeliveryFlag && selectedPlace && selectedPlace.distance > 20) {
					setIsConfirmingOrder(false);
					handleOpenToast(t("Please select a location within 20km distance"), false);
					return;
				}

				const totalAmount = Number(values.the_final_total?.replace(/,/g, ""));

				if (useWallet) {
					if (customerBalance >= totalAmount) {
						// Full wallet payment
						values.payment_method_temp = "wallet";
						setPaymentMethodTemp("wallet");
						if (allTreeData?.details?.order_ability) {
							handleOrderPayment(values, false);
						} else if (allTreeData?.details?.whatsapp) {
							sendToWhatsApp(values, allTreeData.details.whatsapp);
						}

					} else {
						// Mixed payment
						if (payment_method === "Cash") {
							values.payment_method = "Cash";
							values.payment_method_temp = "mix";
							setPaymentMethodTemp("mix");
							if (allTreeData?.details?.order_ability) {
								handleOrderPayment(values, false);
							} else if (allTreeData?.details?.whatsapp) {
								sendToWhatsApp(values, allTreeData.details.whatsapp);
							}

						} else {
							// Online payment for remaining amount
							values.payment_method = "ONL";
							values.payment_method_temp = "mix";
							setPaymentMethodTemp("mix");
							values.amount = totalAmount - customerBalance;
							handleOrderPayment(values, false);

						}
					}
				} else {
					values.payment_method = payment_method;
					if (payment_method === "ONL") {
						values.payment_method_temp = "online";
						values.payment_method = "ONL";
						setPaymentMethodTemp("online");

						const amount = Number(
							basketData?.data?.data?.the_final_total?.replace(/,/g, "")
						);

						const keys = await getPaymobPaymentIntention(amount);
						// initPaymobPixel(keys);
						setOpenPaymobDialog(true);

						setTimeout(() => {
							initPaymobPixel(keys);
						}, 0);
					} else if (payment_method === "Cash") {
						values.payment_method = "Cash";
						values.payment_method_temp = "Cash";
						setPaymentMethodTemp("Cash");
					}
					// Normal payment flow
					if (allTreeData?.details?.order_ability) {
						handleOrderPayment(values, false);
					} else if (allTreeData?.details?.whatsapp) {
						sendToWhatsApp(values, allTreeData.details.whatsapp);
					}

				}
			} else {
				setIsConfirmingOrder(false);
				handleOpenDialog(1);

			}
		} catch (error) {
			handleOpenToast(t("Error processing order"), false);
		}


	};
	useEffect(() => {
		const storedOrderType = getLocalStorageMenuItem("orderType");


		getTimeZone();
		loadTreeData();
		window.scrollTo(0, 0);


		// Load saved cart state if exists
		const savedState = loadCartState();
		if (savedState) {
			setActiveType(savedState.orderType);
			setSelectedPlace(savedState.selectedPlace);
			setPlaceAddress(savedState.placeAddress);
			setSelectedGateway(savedState.selectedGateway || "mada");
			// setPaymentMethod(savedState.payment_method);
			setFormValues(savedState.formValues || {});
			setFormSubmitValues(savedState.formValues || {})
			calcDeliveryFees(savedState?.selectedPlace?.distance || 0);
			setDistanceBetween(savedState.distanceBetween || 0);
			setDurationBetween(savedState.durationBetween || 0);
			setOrderNote(savedState.orderNote || "");
			refetchBasketItemsData(savedState.orderType || activeType, savedState.selectedPlace || selectedPlace, savedState.distanceBetween || distanceBetween);
		}


		if (storedOrderType) {
			const formattedType = storedOrderType;
			if ((formattedType === "dinein" && allTreeData?.details?.is_dinein_active) ||
				(formattedType === "pickup" && allTreeData?.details?.is_pickup_active) ||
				(formattedType === "delivery" && allTreeData?.details?.is_delivery_active)) {
				setActiveType(formattedType);
			}
		}



		// Fetch default address if user is logged in
		if (MobileToken && isDeliveryFlag && !savedState?.selectedPlace && !selectedPlace) {
			fetchDefaultAddress();
		}

		if (isDeliveryFlag && !savedState?.selectedPlace && !selectedPlace && !isLoadingDefaultAddress) {
			if (!check_login) {
				handleOpenDialog(0);
			} else {
				setDeliveryDialogOpen(true);
			}
		}



		fetchWalletBalance().then((newBalance) => {
			setCustomerBalance(newBalance);
		});

		refetchBasket();


	}, []);

	useEffect(() => {
		if (divRef.current) {
			const width = divRef.current.offsetWidth;
			setDivWidth(width);
		}


	}, [basketData]);


	// Also update this useEffect for wallet balance changes:
	useEffect(() => {
		if (useWallet && customerBalance > 0) {
			const totalAmount = Number(basketData?.data?.data?.the_final_total?.replace(/,/g, "") || 0);
			const onlineActive = allTreeData?.details?.is_online_payment_active;
			const cashActive = allTreeData?.details?.is_cash_payment_active;

			if (customerBalance >= totalAmount) {
				// If wallet covers full amount, payment method will be wallet
				setPaymentMethod("wallet");
			} else {
				setPaymentMethod("");
			}

		}
	}, [useWallet, customerBalance, basketData, allTreeData, currencySymbol]);


	if (basketIsLoading || loadingTree || isTabLoading || basketIsFetching) {
		return <Loading backColor={setMobileBackColor()} />;
	}

	const groupOrdersWithOptions = (orders) => {
		const groupedOrders = [];
		let currentParent = null;

		orders?.forEach((order) => {
			if (order.is_order_option === 0) {
				currentParent = {
					...order,
					options: []
				};
				groupedOrders.push(currentParent);
			} else if (order.is_order_option === 1 && currentParent) {
				currentParent.options.push(order);
			} else {
				groupedOrders.push({
					...order,
					options: []
				});
			}
		});

		return groupedOrders;
	};

	return (
		<div className={`min-vh-100`} style={{ backgroundColor: setMobileBackColor() }}>
			<ToastContainer />
			<Container fluid className={`${isDesktop ? 'p-4' : ''}`}>
				<div style={{ marginBottom: 70 }} className="row">


					<FullScreenProgressDialog open={isConfirmingOrder} />
					{isDesktop ? (
						<div className="col-12  mx-auto alignByLang">
							<div className="desktop-container alignByLang" style={{ width: "90%", margin: "0 auto" }}>
								{/* Header */}
								<div className="d-flex justify-content-between align-items-center mb-4 alignByLang">
									<Button
										onClick={handleBack}
										style={{
											color: setMobileTextColor(),
											minWidth: "auto",
											padding: "8px 16px"
										}}
										className="head-font"
									>
										{lang === "ar" ? (
											<ArrowForwardOutlined sx={{ color: setMobileTextColor() }} />
										) : (
											<ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
										)}
										<span className="ms-2">{t("Back")}</span>
									</Button>

									<div className="text-center">
										<p
											className="mb-0 head-font"
											style={{
												color: setMobileTextColor(),
												fontSize: "1.5rem",
												fontWeight: 600
											}}
										>
											{allTreeData?.details?.table}
										</p>
									</div>
								</div>

								{/* Main Content Grid */}
								<Formik
									onSubmit={handleSubmit}
									initialValues={basketData?.data.data || {}}
									enableReinitialize
									key={activeType}
								>
									{({ errors, setFieldValue, values, handleSubmit }) => (
										<Form>
											<div className="row g-4">
												{/* Left Column - Order Details */}
												<div className="col-12 col-lg-8">
													{/* Order Type Selection */}
													<div
														className="head-font mb-4"
														style={{
															display: "flex",
															justifyContent: "center",
															backgroundColor: setMobileBackColor(),
															borderRadius: "12px",
															boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
															overflow: "hidden",
															border: `1px solid ${setMobileCardBorderColor()}`,
															position: "relative",
														}}
													>
														{isTabLoading && (
															<div
																style={{
																	position: "absolute",
																	top: 0,
																	left: 0,
																	right: 0,
																	bottom: 0,
																	backgroundColor: "rgba(255, 255, 255, 0.7)",
																	display: "flex",
																	justifyContent: "center",
																	alignItems: "center",
																	zIndex: 1,
																}}
															>
																<CircularProgress
																	size={24}
																	style={{ color: setMobileButttonBackColor() }}
																/>
															</div>
														)}

														{allTreeData?.details?.is_dinein_active && (params.get("t") && params.get("t") !== "null") ? (
															<div
																style={{
																	flex: 1,
																	padding: isDesktop ? "16px 24px" : "14px 24px",
																	border: "none",
																	fontSize: "16px",
																	fontWeight: 600,
																	borderRight: `1px solid ${setMobileCardBorderColor()}`,
																	borderColor: isDineInFlag ? setMobileButttonBackColor() : "transparent",
																	borderWidth: isDineInFlag ? "0 0 3px 0" : "0",
																	borderStyle: "solid",
																	backgroundColor: isDineInFlag ? setMobileCardColor() : setMobileBackColor(),
																	color: isDineInFlag ? setMobileButttonBackColor() : setMobileTextColor(),
																	textAlign: "center",
																}}
															>
																{t("Dine-In")}
															</div>
														) : (
															<>
																{allTreeData?.details?.is_delivery_active && (
																	<div
																		style={{
																			flex: 1,
																			padding: isDesktop ? "16px 24px" : "14px 24px",
																			border: "none",
																			fontSize: "16px",
																			fontWeight: 600,
																			borderColor: isDeliveryFlag ? setMobileButttonBackColor() : "transparent",
																			borderWidth: isDeliveryFlag ? "0 0 3px 0" : "0",
																			borderStyle: "solid",
																			backgroundColor: isDeliveryFlag ? setMobileCardColor() : setMobileBackColor(),
																			color: isDeliveryFlag ? setMobileButttonBackColor() : setMobileTextColor(),
																			textAlign: "center",
																		}}
																	>
																		{t("Delivery")}
																	</div>
																)}
																{allTreeData?.details?.is_pickup_active && (
																	<div
																		style={{
																			flex: 1,
																			padding: isDesktop ? "16px 24px" : "14px 24px",
																			border: "none",
																			fontSize: "16px",
																			fontWeight: 600,
																			borderRight: allTreeData?.details?.is_delivery_active ? `1px solid ${setMobileCardBorderColor()}` : "none",
																			borderColor: isPickupFlag ? setMobileButttonBackColor() : "transparent",
																			borderWidth: isPickupFlag ? "0 0 3px 0" : "0",
																			borderStyle: "solid",
																			backgroundColor: isPickupFlag ? setMobileCardColor() : setMobileBackColor(),
																			color: isPickupFlag ? setMobileButttonBackColor() : setMobileTextColor(),
																			textAlign: "center",
																		}}
																	>
																		{t("Pickup")}
																	</div>
																)}
															</>
														)}
													</div>

													{!JSON.parse(params.get("t")) && activeType !== "dinein" && activeType && activeType !== "browse" && (
														<div
															onClick={() => setOrderTypeDialogOpen(true)}
															style={{
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'center',
																cursor: 'pointer',
																marginBottom: '24px',
																padding: '12px 16px',
																backgroundColor: setMobileCardColor(),
																border: `1px solid ${setMobileCardBorderColor()}`,
																borderRadius: '12px',
																gap: '8px',
																transition: 'all 0.2s ease',
															}}
															onMouseEnter={(e) => e.currentTarget.style.backgroundColor = setMobileButttonBackColor() + '10'}
															onMouseLeave={(e) => e.currentTarget.style.backgroundColor = setMobileCardColor()}
														>
															<Edit fontSize="small" style={{ color: setMobileButttonBackColor() }} />
															<Typography className={isDesktop ? "head-font" : "sub-font"} style={{
																color: setMobileTextColor(),
																fontSize: isDesktop ? '16px' : '14px',
																fontWeight: 600
															}}>
																{getOrderTypeDisplayText(activeType)}
															</Typography>
														</div>
													)}

													{/* Show selection prompt if in browse mode */}
													{activeType === "browse" && (
														<div
															onClick={() => setOrderTypeDialogOpen(true)}
															style={{
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'center',
																cursor: 'pointer',
																marginBottom: '24px',
																padding: '16px',
																backgroundColor: setMobileButttonBackColor() + '10',
																border: `2px dashed ${setMobileButttonBackColor()}`,
																borderRadius: '12px',
																gap: '8px',
																transition: 'all 0.2s ease',
															}}
															onMouseEnter={(e) => e.currentTarget.style.backgroundColor = setMobileButttonBackColor() + '20'}
															onMouseLeave={(e) => e.currentTarget.style.backgroundColor = setMobileButttonBackColor() + '10'}
														>
															<Edit fontSize="small" style={{ color: setMobileButttonBackColor() }} />
															<Typography className="head-font" style={{
																color: setMobileButttonBackColor(),
																fontSize: '16px',
																fontWeight: 600,
																textAlign: 'center'
															}}>
																{t("Select Order Type to Continue")}
															</Typography>
														</div>
													)}

													{/* Pickup Venue Section */}
													{/* {isPickupFlag && allTreeData?.details?.is_pickup_active && allTreeData?.details?.pickup_venues?.length > 0 && (
														<div
															className="mb-4 p-4 rounded-3 sub-font"
															style={{
																color: setMobileTextColor(),
																border: `1px solid ${setMobileCardBorderColor()}`,
																backgroundColor: setMobileCardColor(),
																borderRadius: "12px",
																boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
															}}
														>
															<TextField
																select
																id="pickupVenue"
																name="pickupVenue"
																label={
																	<span className="sub-font">
																		{allTreeData.details.pickup_venues.length === 1
																			? t("Pickup Venue")
																			: t("Select Pickup Venue")}
																	</span>
																}
																required={isPickupFlag}
																value={
																	allTreeData.details.pickup_venues.length === 1
																		? allTreeData.details.pickup_venues[0]?.id
																		: values.pickupVenue
																}
																onChange={(e) => setFieldValue("pickupVenue", e.target.value)}
																className="rounded-2 sub-font"
																size="medium"
																fullWidth
																sx={{
																	backgroundColor: setMobileCardColor(),
																	"& .MuiOutlinedInput-root": { borderRadius: "8px" },
																	"& .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileCardBorderColor(),
																	},
																	"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileButttonBackColor(),
																	},
																	"& .MuiInputBase-input": {
																		color: setMobileTextColor() || "#333",
																		fontFamily:
																			["ar", "fa"].includes(getLocalStorageMenuItem("lang"))
																				? "Almarai"
																				: "Roboto, sans-serif",
																		fontWeight: 500,
																		letterSpacing: "0.5px",
																	},
																	"& .MuiInputLabel-root": {
																		color: setMobileTextColor() || "#555",
																		fontWeight: 500,
																	},
																	"& .MuiInputLabel-root.Mui-focused": {
																		color: setMobileButttonBackColor(),
																	},
																}}
															>
																{allTreeData.details.pickup_venues.map((venue) => (
																	<MenuItem
																		className="sub-font"
																		key={venue.id}
																		value={venue.id}
																		sx={{
																			color: setMobileTextColor() || "#333",
																			fontFamily:
																				["ar", "fa"].includes(getLocalStorageMenuItem("lang"))
																					? "Almarai"
																					: "Roboto, sans-serif",
																			fontWeight: 500,
																			"&:hover": {
																				backgroundColor: setMobileButttonBackColor() + "20",
																			},
																		}}
																	>
																		{venue.name}
																	</MenuItem>
																))}
															</TextField>
														</div>
													)} */}

													{isPickupFlag && allTreeData?.details?.is_pickup_active && allTreeData?.details?.pickup_venues?.length > 0 && (
														<div
															className="mb-4 p-4 rounded-3 sub-font"
															style={{
																color: setMobileTextColor(),
																border: `1px solid ${setMobileCardBorderColor()}`,
																backgroundColor: setMobileCardColor(),
																borderRadius: "12px",
																boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
															}}
														>
															<TextField
																select
																id="pickupVenue"
																name="pickupVenue"
																label={
																	<span className="sub-font">
																		{allTreeData.details.pickup_venues.length === 1
																			? t("Pickup Venue")
																			: t("Select Pickup Venue")}
																	</span>
																}
																required={isPickupFlag}
																value={
																	allTreeData.details.pickup_venues.length === 1
																		? allTreeData.details.pickup_venues[0]?.id
																		: values.pickupVenue
																}
																onChange={(e) => setFieldValue("pickupVenue", e.target.value)}
																className="rounded-2 sub-font"
																size="medium"
																fullWidth
																sx={{
																	backgroundColor: setMobileCardColor(),
																	"& .MuiOutlinedInput-root": { borderRadius: "8px" },
																	"& .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileCardBorderColor(),
																	},
																	"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileButttonBackColor(),
																	},
																	"& .MuiInputBase-input": {
																		color: setMobileTextColor() || "#333",
																		fontFamily:
																			["ar", "fa"].includes(getLocalStorageMenuItem("lang"))
																				? "Almarai"
																				: "Roboto, sans-serif",
																		fontWeight: 500,
																		letterSpacing: "0.5px",
																	},
																	"& .MuiInputLabel-root": {
																		color: setMobileTextColor() || "#555",
																		fontWeight: 500,
																	},
																	"& .MuiInputLabel-root.Mui-focused": {
																		color: setMobileButttonBackColor(),
																	},
																}}
																SelectProps={{
																	MenuProps: {
																		sx: {
																			"& .MuiPaper-root": {
																				backgroundColor: setMobileCardColor(), // Dropdown background
																				borderRadius: "8px",
																				boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
																				"& .MuiMenuItem-root": {
																					backgroundColor: setMobileCardColor(), // Menu item background
																					color: setMobileTextColor() || "#333",
																					fontFamily: ["ar", "fa"].includes(getLocalStorageMenuItem("lang"))
																						? "Almarai"
																						: "Roboto, sans-serif",
																					fontWeight: 500,
																					"&:hover": {
																						backgroundColor: setMobileButttonBackColor() + "20",
																					},
																					"&.Mui-selected": {
																						backgroundColor: setMobileButttonBackColor() + "40",
																						"&:hover": {
																							backgroundColor: setMobileButttonBackColor() + "60",
																						},
																					},
																				},
																			},
																		},
																	},
																}}
															>
																{allTreeData.details.pickup_venues.map((venue) => (
																	<MenuItem
																		className="sub-font"
																		key={venue.id}
																		value={venue.id}
																		sx={{
																			color: setMobileTextColor() || "#333",
																			fontFamily:
																				["ar", "fa"].includes(getLocalStorageMenuItem("lang"))
																					? "Almarai"
																					: "Roboto, sans-serif",
																			fontWeight: 500,
																		}}
																	>
																		{venue.name}
																	</MenuItem>
																))}
															</TextField>
														</div>
													)}

													{/* Delivery Address Section */}
													{isDeliveryFlag && (
														<>
															<div
																className="mb-4 p-4 rounded-3 alignByLang sub-font"
																style={{
																	border: `1px solid ${setMobileCardBorderColor()}`,
																	backgroundColor: setMobileCardColor(),
																	borderRadius: "12px",
																	boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
																}}
																ref={divRef}
															>
																<div className="d-flex justify-content-between align-items-center mb-3">
																	<label
																		htmlFor="address"
																		className="font-size-16 mb-0 sub-font"
																		style={{
																			color: setMobileTextColor(),
																			fontWeight: 600,
																		}}
																	>
																		<LocalShippingOutlined
																			className={`${getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fa" ? "ms-2" : "me-2"}`}
																			fontSize="large"
																			style={{
																				color: setMobileButttonBackColor(),
																				verticalAlign: "middle",
																			}}
																		/>{" "}
																		{t("Address")}
																	</label>

																	<Box
																		component="div"
																		onClick={() => {
																			if (!check_login) {
																				handleOpenDialog(0);
																			} else {
																				setDeliveryDialogOpen(true);
																			}
																		}}
																		sx={{
																			px: 3,
																			py: 1.5,
																			display: "flex",
																			alignItems: "center",
																			backgroundColor: setMobileButttonBackColor() + '10',
																			borderRadius: "20px",
																			cursor: "pointer",
																			border: `1px solid ${setMobileCardBorderColor()}`,
																			transition: "all 0.2s ease",
																			'&:hover': {
																				backgroundColor: setMobileButttonBackColor() + '20',
																			}
																		}}
																	>
																		<EditLocationAltOutlined
																			sx={{
																				mr: 1,
																				color: setMobileButttonBackColor(),
																			}}
																			fontSize="small"
																		/>
																		<Typography
																			variant="body2"
																			className="sub-font"
																			sx={{
																				color: setMobileTextColor(),
																				overflow: "hidden",
																				textOverflow: "ellipsis",
																				whiteSpace: "nowrap",
																				fontWeight: 500,
																			}}
																		>
																			{selectedPlace?.title || placeAddress || t("Select Delivery Location")}
																		</Typography>
																	</Box>
																</div>

																<TextField
																	id="address"
																	name="address"
																	type="address"
																	variant="outlined"
																	value={values.address || placeAddress || ""}
																	onChange={(e) => setFieldValue("address", e.target.value)}
																	placeholder={t("Address description")}
																	helperText={errors.address && errors.address}
																	className="rounded-2 sub-font"
																	error={errors.address}
																	size="medium"
																	fullWidth
																	sx={{
																		backgroundColor: setMobileCardColor(),
																		"& .MuiOutlinedInput-root": {
																			borderRadius: "8px",
																		},
																		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																			borderColor: setMobileButttonBackColor(),
																		},
																		"& .MuiInputBase-input": {
																			color: setMobileTextColor(),
																			fontFamily:
																				getLocalStorageMenuItem("lang") === "ar" ||
																					getLocalStorageMenuItem("lang") === "fa"
																					? "Almarai"
																					: "Roboto",
																		},
																		"& .MuiInputLabel-root": {
																			color: setMobileTextColor(),
																		},
																		"& .MuiFormHelperText-root": {
																			color: "#f44336",
																		},
																		"& .MuiOutlinedInput-notchedOutline": {
																			borderColor: setMobileCardBorderColor(),
																		},
																		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																			borderColor: setMobileButttonBackColor(),
																		},
																	}}
																/>
															</div>
															{selectedPlace && allTreeData?.details?.venue_latitude && allTreeData?.details?.venue_longitude && (
																<div className="mb-4">
																	<VenueToLocationMap
																		venueLocation={{
																			lat: parseFloat(allTreeData.details.venue_latitude),
																			lng: parseFloat(allTreeData.details.venue_longitude)
																		}}
																		selectedLocation={selectedPlace}
																	/>
																</div>
															)}
															<input hidden={true} name="address_id" id="address_id" value={selectedPlace?.id || ""} />
														</>
													)}

													{/* Order Details Section */}
													<div
														className="mb-4 rounded-3"
														style={{
															border: `1px solid ${setMobileCardBorderColor()}`,
															backgroundColor: setMobileCardColor(),
															borderRadius: "12px",
															boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
															padding: "24px"
														}}
													>
														<div className="d-flex justify-content-between align-items-center mb-3">
															<label
																className="font-size-16 mb-0 head-font"
																style={{
																	color: setMobileTextColor(),
																	display: "flex",
																	alignItems: "center",
																	fontWeight: 600,
																}}
															>
																<DescriptionOutlined
																	className={`${getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fa" ? "ms-2" : "me-2"}`}
																	style={{
																		color: setMobileButttonBackColor(),
																	}}
																	fontSize="large"
																/>
																{t("Order details")}
															</label>

															<Button
																onClick={() => setConfirmEmptyDialog(true)}
																style={{
																	color: setMobileTextColor(),
																	backgroundColor: "rgba(211, 47, 47, 0.04)",
																	fontWeight: 600,
																	fontSize: "14px",
																	letterSpacing: "0.3px",
																	border: `1px solid ${setMobileTextColor()}`,
																	borderRadius: "8px",
																	padding: "8px 16px",
																	textTransform: "none",
																	transition: "all 0.2s ease-in-out",
																}}
																startIcon={<DeleteOutline sx={{ fontSize: "18px" }} />}
																className="head-font"
																onMouseEnter={(e) => {
																	e.target.style.backgroundColor = "rgba(211, 47, 47, 0.08)";
																	e.target.style.transform = "translateY(-1px)";
																}}
																onMouseLeave={(e) => {
																	e.target.style.backgroundColor = "rgba(211, 47, 47, 0.04)";
																	e.target.style.transform = "translateY(0)";
																}}
															>
																{t("Empty Cart")}
															</Button>
														</div>
														{groupOrdersWithOptions(values?.items)?.map((order) => (
															<Order
																key={order.index}
																order={order}
																handleOpenToast={handleOpenToast}
																currency={currencySymbol}
																tableQr={tableQr}
																tableName={tableName}
																refetch={refetchBasket}
																ordersLength={values?.items?.length || 0}
																isDesktop={isDesktop}
															/>
														))}
													</div>

													{/* Coupon Section */}
													<div
														className="mb-4 p-4 rounded-3"
														style={{
															border: `1px solid ${setMobileCardBorderColor()}`,
															backgroundColor: setMobileCardColor(),
															borderRadius: "12px",
															boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
														}}
													>
														<label
															className="font-size-16 mb-3 sub-font"
															style={{
																color: setMobileTextColor(),
																display: "flex",
																alignItems: "center",
																fontWeight: 600,
															}}
														>
															<LocalOfferOutlined
																className={`${getLocalStorageMenuItem("lang") === "ar" ||
																	getLocalStorageMenuItem("lang") === "fa"
																	? "ms-2"
																	: "me-2"
																	}`}
																style={{
																	color: setMobileButttonBackColor(),
																}}
																fontSize="large"
															/>
															{t("Coupon Code")}
														</label>

														<div className="d-flex gap-3 align-items-end">
															<TextField
																value={couponCode}
																onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
																placeholder={t("Enter coupon code")}
																size="medium"
																fullWidth
																sx={{
																	backgroundColor: setMobileCardColor(),
																	"& .MuiOutlinedInput-root": {
																		borderRadius: "8px",
																	},
																	"& .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileCardBorderColor(),
																	},
																	"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileButttonBackColor(),
																	},
																	"& .MuiInputBase-input": {
																		color: setMobileTextColor(),
																		fontFamily:
																			getLocalStorageMenuItem("lang") === "ar" ||
																				getLocalStorageMenuItem("lang") === "fa"
																				? "Almarai"
																				: "Roboto",
																	},
																}}
															/>
															<LoadingButton
																loading={couponLoading}
																onClick={handleApplyCoupon}
																variant="contained"
																size="medium"
																sx={{
																	backgroundColor: setMobileButttonBackColor(),
																	color: setMobileHighlightTextColor() || setMobileTextColor(),
																	minWidth: "120px",
																	borderRadius: "8px",
																	textTransform: "none",
																	fontFamily:
																		getLocalStorageMenuItem("lang") === "ar" ||
																			getLocalStorageMenuItem("lang") === "fa"
																			? "Almarai"
																			: "Roboto",
																	fontWeight: 600,
																	"&:hover": {
																		backgroundColor: setMobileButttonBackColor() + "CC",
																	},
																	"&.Mui-disabled": {
																		backgroundColor: setMobileCardBorderColor(),
																		color: setMobileTextColor() + "60",
																	},
																}}
															>
																{t("Apply")}
															</LoadingButton>
														</div>

														{appliedCoupon && (
															<div
																className="mt-3 p-3"
																style={{
																	backgroundColor: setMobileButttonBackColor() + "10",
																	borderRadius: "8px",
																	border: `1px solid ${setMobileButttonBackColor()}30`,
																}}
															>
																<Typography
																	className="sub-font"
																	style={{
																		color: setMobileButttonBackColor(),
																		fontWeight: 600,
																		marginBottom: "8px",
																	}}
																>
																	✓ {t("Coupon Applied Successfully")}
																</Typography>
																<Typography
																	className="sub-font"
																	style={{
																		color: setMobileButttonBackColor(),
																		fontSize: "16px",
																		fontWeight: 600,
																	}}
																>
																	{t("Total Discount")}: {appliedCoupon.total_discount}
																</Typography>
															</div>
														)}
													</div>

													{/* Order Notes Section */}
													<div
														className="mb-4 p-4 rounded-3"
														style={{
															border: `1px solid ${setMobileCardBorderColor()}`,
															backgroundColor: setMobileCardColor(),
															borderRadius: "12px",
															boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
														}}
													>
														<label
															htmlFor="note"
															className="font-size-16 mb-3 sub-font"
															style={{
																color: setMobileTextColor(),
																fontWeight: 600,
															}}
														>
															{t("Note")}
														</label>
														<TextField
															id="note"
															name="note"
															type="note"
															variant="outlined"
															value={orderNote}
															onChange={(e) => {
																setFieldValue("note", e.target.value);
																setOrderNote(e.target.value);
															}}
															placeholder={t("Enter your note")}
															helperText={errors.note && errors.note}
															className="rounded-2 sub-font"
															error={errors.note}
															size="medium"
															fullWidth
															multiline
															rows={4}
															sx={{
																backgroundColor: setMobileCardColor(),
																"& .MuiOutlinedInput-root": {
																	borderRadius: "8px",
																},
																"& .MuiOutlinedInput-notchedOutline": {
																	borderColor: setMobileCardBorderColor(),
																},
																"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																	borderColor: setMobileButttonBackColor(),
																},
																"& .MuiInputBase-input": {
																	color: setMobileTextColor(),
																	fontFamily:
																		getLocalStorageMenuItem("lang") === "ar" ||
																			getLocalStorageMenuItem("lang") === "fa"
																			? "Almarai"
																			: "Roboto",
																},
																"& .MuiInputLabel-root": {
																	color: setMobileTextColor(),
																},
																"& .MuiFormHelperText-root": {
																	color: "#f44336",
																},
															}}
														/>
													</div>

													{/* Submit Button in Left Column */}
													{(!allTreeData?.details?.order_ability && !allTreeData?.details?.whatsapp) ||
														(values?.length === 0 || basketData?.data?.data?.length === 0) ? null : (
														<div className="mt-4 text-center">
															{isLoadingOrder ? (
																<Button
																	className="head-font w-100"
																	variant="contained"
																	style={{
																		backgroundColor: setMobileButttonBackColor(),
																		color: setMobileHighlightTextColor() || setMobileTextColor(),
																		borderRadius: "12px",
																		padding: "12px 24px",
																		fontSize: "16px",
																		fontWeight: 600,
																		height: "48px",
																	}}
																	disabled
																>
																	<CircularProgress
																		style={{ color: setMobileHighlightTextColor() || setMobileTextColor() }}
																		className="mx-2"
																		size={20}
																	/>
																	{t("Processing...")}
																</Button>
															) : (
																<Button
																	className="w-100 head-font"
																	type="submit"
																	variant="contained"
																	disabled={allTreeData?.details?.is_online_payment_active === false && allTreeData?.details?.is_cash_payment_active === false}
																	style={{
																		backgroundColor: setMobileButttonBackColor(),
																		color: setMobileHighlightTextColor() || setMobileTextColor(),
																		borderRadius: "12px",
																		padding: "12px 24px",
																		fontSize: "16px",
																		fontWeight: 600,
																		height: "48px",
																		boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
																	}}
																>
																	{t("confirm order")}
																</Button>
															)}
														</div>
													)}
												</div>

												{/* Right Column - Summary & Payment */}
												<div className="col-12 col-lg-4">
													<div className="sticky-top" style={{ top: "20px" }}>
														{/* Payment Details Section */}
														<div
															className="mb-4 p-4 rounded-3"
															style={{
																border: `1px solid ${setMobileCardBorderColor()}`,
																backgroundColor: setMobileCardColor(),
																borderRadius: "12px",
																boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
															}}
														>
															<label
																className="font-size-16 mb-3 head-font"
																style={{
																	color: setMobileTextColor(),
																	display: "flex",
																	alignItems: "center",
																	fontWeight: 600,
																}}
															>
																<DescriptionOutlined
																	className={`${getLocalStorageMenuItem("lang") === "ar" ||
																		getLocalStorageMenuItem("lang") === "fa"
																		? "ms-2"
																		: "me-2"
																		}`}
																	style={{
																		color: setMobileButttonBackColor(),
																	}}
																	fontSize="large"
																/>
																{t("Order details")}
															</label>

															<div className="m-top-12">
																<p
																	className="d-flex justify-content-between sub-font"
																	style={{
																		color: setMobileTextColor(),
																		margin: "12px 0",
																	}}
																>
																	<span className="font-size-14">
																		{t("Subtotal")}
																	</span>
																	<span className="font-size-14">
																		{values.the_sub_total}
																		<span className="font-size-14 mx-2">
																			{currencySymbol === "SAR" ? (
																				<img width={16} height={16} src={SARIconThemeColor()} className="mr-1" />
																			) : (
																				currencySymbol
																			)}
																		</span>
																	</span>
																</p>

																{appliedCoupon && values?.the_items_discount > 0 && (
																	<p
																		className="d-flex justify-content-between sub-font"
																		style={{
																			color: setMobileButttonBackColor(),
																			margin: "12px 0",
																		}}
																	>
																		<span className="font-size-14">
																			{t("Items Discount")}
																		</span>
																		<span className="font-size-14">
																			-{Number(values?.the_items_discount || 0).toFixed(2)}
																			<span className="font-size-14 mx-2">
																				{currencySymbol === "SAR" ? (
																					<img width={16} height={16} src={SARIconThemeColor()} className="mr-1" />
																				) : (
																					currencySymbol
																				)}
																			</span>
																		</span>
																	</p>
																)}

																{values?.tax && (
																	<p
																		className="d-flex justify-content-between sub-font"
																		style={{
																			color: setMobileTextColor(),
																			margin: "12px 0",
																		}}
																	>
																		<span className="font-size-14">{t("Tax")} {" "}({t("15%")})</span>
																		<span className="font-size-14">
																			{values.the_tax}
																			<span className="font-size-14 mx-2">
																				{currencySymbol === "SAR" ? (
																					<img width={16} height={16} src={SARIconThemeColor()} className="mr-1" />
																				) : (
																					currencySymbol
																				)}
																			</span>
																		</span>
																	</p>
																)}

																{values?.tax_admin > 0 && (
																	<p
																		className="d-flex justify-content-between sub-font"
																		style={{
																			color: setMobileTextColor(),
																			margin: "12px 0",
																		}}
																	>
																		<span className="font-size-14">{t("Admin tax")}{" "}({t("15%")})</span>
																		<span className="font-size-14">
																			{values?.tax_admin}
																			<span className="font-size-14 mx-2">
																				{currencySymbol === "SAR" ? (
																					<img width={16} height={16} src={SARIconThemeColor()} className="mr-1" />
																				) : (
																					currencySymbol
																				)}
																			</span>
																		</span>
																	</p>
																)}

																{isDeliveryFlag && allTreeData?.details?.is_delivery_active && (
																	<>
																		<p
																			className="d-flex justify-content-between sub-font"
																			style={{
																				color: setMobileTextColor(),
																				margin: "12px 0",
																			}}
																		>
																			<span className="font-size-14">
																				{t("Delivery Amount")}
																			</span>
																			<span className="font-size-14">
																				{Number(values?.the_delivery_amount || 0)}
																				<span className="font-size-14 mx-2">
																					{currencySymbol === "SAR" ? (
																						<img width={16} height={16} src={SARIconThemeColor()} className="mr-1" />
																					) : (
																						currencySymbol
																					)}
																				</span>
																			</span>
																		</p>

																		{appliedCoupon && values?.the_delivery_discount > 0 && (
																			<p
																				className="d-flex justify-content-between sub-font"
																				style={{
																					color: setMobileButttonBackColor(),
																					margin: "12px 0",
																				}}
																			>
																				<span className="font-size-14">
																					{t("Delivery Discount")}
																				</span>
																				<span className="font-size-14">
																					-{Number(values?.the_delivery_discount || 0).toFixed(2)}
																					<span className="font-size-14 mx-2">
																						{currencySymbol === "SAR" ? (
																							<img width={16} height={16} src={SARIconThemeColor()} className="mr-1" />
																						) : (
																							currencySymbol
																						)}
																					</span>
																				</span>
																			</p>
																		)}

																		<p
																			className="d-flex justify-content-between sub-font"
																			style={{
																				color: setMobileTextColor(),
																				margin: "12px 0",
																			}}
																		>
																			<span className="font-size-14">
																				{t("Delivery Tax")}{" "}({t("15%")})
																			</span>
																			<span className="font-size-14">
																				{Number(values?.the_delivery_tax || 0)}
																				<span className="font-size-14 mx-2">
																					{currencySymbol === "SAR" ? (
																						<img width={16} height={16} src={SARIconThemeColor()} className="mr-1" />
																					) : (
																						currencySymbol
																					)}
																				</span>
																			</span>
																		</p>
																	</>
																)}

																<hr style={{ borderTop: `1px solid ${setMobileCardBorderColor()}`, margin: "16px 0" }} />

																<p
																	className="d-flex justify-content-between head-font"
																	style={{
																		color: setMobileTextColor(),
																		margin: "16px 0",
																	}}
																>
																	<span className="font-size-18" style={{ fontWeight: 600 }}>{t("Total")}</span>
																	<span className="font-size-18" style={{
																		color: setMobileButttonBackColor(),
																		fontWeight: 600,
																	}}>
																		{Number(values?.the_total || 0).toFixed(2) || 0}
																		<span className="font-size-18 mx-2">
																			{currencySymbol === "SAR" ? (
																				<img width={18} height={18} src={SARIconThemeColor()} className="mr-1" />
																			) : (
																				currencySymbol
																			)}
																		</span>
																	</span>
																</p>

																<hr style={{ borderTop: `1px solid ${setMobileCardBorderColor()}`, margin: "16px 0" }} />

																<p
																	className="d-flex justify-content-between head-font"
																	style={{
																		color: setMobileTextColor(),
																		margin: "16px 0",
																	}}
																>
																	<span className="font-size-20" style={{ fontWeight: 700 }}>{t("End Total")}</span>
																	<span className="font-size-20" style={{
																		color: setMobileButttonBackColor(),
																		fontWeight: 700,
																	}}>
																		{Number(values?.the_final_total || 0).toFixed(2)}
																		<span className="font-size-20 mx-2">
																			{currencySymbol === "SAR" ? (
																				<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																			) : (
																				currencySymbol
																			)}
																		</span>
																	</span>
																</p>
															</div>
														</div>

														{/* Payment Method Section */}
														<div
															className="mb-4 p-4 rounded-3"
															style={{
																border: `1px solid ${setMobileCardBorderColor()}`,
																backgroundColor: setMobileCardColor(),
																borderRadius: "12px",
																boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
															}}
														>
															{customerBalance > 0 && (
																<FormControlLabel
																	control={
																		<Checkbox
																			checked={useWallet}
																			onChange={(e) => setUseWallet(e.target.checked)}
																			sx={{
																				color: setMobileButttonBackColor(),
																				'&.Mui-checked': {
																					color: setMobileButttonBackColor(),
																				},
																			}}
																		/>
																	}
																	label={
																		<Typography className="sub-font" style={{ color: setMobileTextColor(), fontSize: "14px" }}>
																			{t("Use Wallet Balance")} ({currencySymbol} {customerBalance.toFixed(2)})
																		</Typography>
																	}
																	sx={{ mb: 2 }}
																/>
															)}

															{/* Payment Method Section - Desktop */}
															<FormControl component="fieldset" fullWidth>
																<FormLabel
																	component="legend"
																	className="sub-font"
																	sx={{
																		color: setMobileTextColor(),
																		fontWeight: 600,
																		marginBottom: 2,
																		'&.Mui-focused': {
																			color: setMobileButttonBackColor(),
																		}
																	}}
																>
																	{t("Payment Method")}
																</FormLabel>

																<RadioGroup
																	value={payment_method}
																	onChange={(e) => {
																		setFieldValue("payment_method", e.target.value);
																		setPaymentMethod(e.target.value);
																	}}
																	name="payment_method"
																>
																	{/* Check both payment method flags */}
																	{allTreeData?.details?.is_online_payment_active && (
																		isDineInFlag && allTreeData?.details?.is_dinein_active ?
																			allTreeData?.details?.is_dinein_online_payment_active && (
																				<FormControlLabel
																					value="ONL"
																					control={
																						<Radio
																							sx={{
																								color: setMobileButttonBackColor(),
																								'&.Mui-checked': {
																									color: setMobileButttonBackColor(),
																								},
																							}}
																						/>
																					}
																					label={
																						<Typography className="sub-font" style={{ color: setMobileTextColor() }}>
																							{t("PAY ONLINE")}
																						</Typography>
																					}
																					disabled={useWallet && customerBalance >= Number(values.the_final_total?.replace(/,/g, ""))}
																				/>
																			)
																			: (
																				<FormControlLabel
																					value="ONL"
																					control={
																						<Radio
																							sx={{
																								color: setMobileButttonBackColor(),
																								'&.Mui-checked': {
																									color: setMobileButttonBackColor(),
																								},
																							}}
																						/>
																					}
																					label={
																						<Typography className="sub-font" style={{ color: setMobileTextColor() }}>
																							{t("PAY ONLINE")}
																						</Typography>
																					}
																					disabled={useWallet && customerBalance >= Number(values.the_final_total?.replace(/,/g, ""))}
																				/>
																			)
																	)}

																	{allTreeData?.details?.is_cash_payment_active && (
																		<FormControlLabel
																			value="Cash"
																			control={
																				<Radio
																					sx={{
																						color: setMobileButttonBackColor(),
																						'&.Mui-checked': {
																							color: setMobileButttonBackColor(),
																						},
																					}}
																				/>
																			}
																			label={
																				<Typography className="sub-font" style={{ color: setMobileTextColor() }}>
																					{t("Cash")}
																				</Typography>
																			}
																			disabled={useWallet && customerBalance >= Number(values.the_final_total?.replace(/,/g, ""))}
																		/>
																	)}

																	{!allTreeData?.details?.is_online_payment_active && !allTreeData?.details?.is_cash_payment_active && (
																		<Typography className="sub-font" style={{ color: setMobileTextColor(), padding: "8px" }}>
																			{t("No payment methods available")}
																		</Typography>
																	)}
																</RadioGroup>

																{!payment_method && (
																	<Typography
																		className="sub-font"
																		sx={{
																			color: "#f44336",
																			fontSize: "0.75rem",
																			marginTop: 1
																		}}
																	>
																		{t("Please select a payment method")}
																	</Typography>
																)}
															</FormControl>
														</div>
													</div>
												</div>
											</div>
										</Form>
									)}
								</Formik>
							</div>
						</div>
					) : (
						<div className=" ms-auto p-0">
							<div className="mobile-side-screen">
								<div>
									<div>
										<Navbar
											className={`d-flex justify-content-between align-items-center position-fixed top-0 z-2 mobile-nav `}
											style={{
												width: "100%",
												margin: "auto",
												backgroundColor: setMobileBackColor(),
											}}
										>
											<Button
												onClick={handleBack}
												style={{ color: setMobileTextColor() }}
											>
												<ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
											</Button>

											<Navbar.Brand className="text-center m-0">
												<p
													className="mb-1 text-center sub-font"
													style={{ color: setMobileTextColor() }}
												>
													{allTreeData?.details?.table}
												</p>
											</Navbar.Brand>
											<Button sx={{ color: setMobileTextColor() }}></Button>
										</Navbar>
									</div>
								</div>
								<div className="sections mx-2 alignByLang">
									<div style={{ marginTop: "60px", marginBottom: "24px" }}>
										<Formik
											onSubmit={handleSubmit}
											initialValues={basketData?.data.data || {}}
											enableReinitialize
											key={activeType}
										>
											{({ errors, setFieldValue, values }) => (
												<Form>
													{/* Order Type Selection */}
													<div
														className="head-font"
														style={{
															display: "flex",
															justifyContent: "center",
															backgroundColor: setMobileBackColor(),
															borderRadius: "12px",
															boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
															marginBottom: "24px",
															overflow: "hidden",
															border: `1px solid ${setMobileCardBorderColor()}`,
															position: "relative",
														}}
													>
														{isTabLoading && (
															<div
																style={{
																	position: "absolute",
																	top: 0,
																	left: 0,
																	right: 0,
																	bottom: 0,
																	backgroundColor: "rgba(255, 255, 255, 0.7)",
																	display: "flex",
																	justifyContent: "center",
																	alignItems: "center",
																	zIndex: 1,
																}}
															>
																<CircularProgress
																	size={24}
																	style={{ color: setMobileButttonBackColor() }}
																/>
															</div>
														)}

														{allTreeData?.details?.is_dinein_active && (params.get("t") && params.get("t") !== "null") ? (
															<div
																style={{
																	// flex: 1,
																	padding: isDesktop ? "16px 24px" : "14px 24px",
																	border: "none",
																	fontSize: "16px",
																	fontWeight: 600,
																	borderRight: `1px solid ${setMobileCardBorderColor()}`,
																	borderColor: isDineInFlag ? setMobileButttonBackColor() : "transparent",
																	borderWidth: isDineInFlag ? "0 0 3px 0" : "0",
																	borderStyle: "solid",
																	// backgroundColor: isDineInFlag ? setMobileCardColor() : setMobileBackColor(),
																	color: isDineInFlag ? setMobileButttonBackColor() : setMobileTextColor(),
																	textAlign: "center",
																}}
															>
																{t("Dine-In")}
															</div>
														) : (
															<>
																{allTreeData?.details?.is_delivery_active && (
																	<div
																		style={{
																			// flex: 1,
																			padding: isDesktop ? "16px 24px" : "14px 24px",
																			border: "none",
																			fontSize: "16px",
																			fontWeight: 600,
																			borderColor: isDeliveryFlag ? setMobileButttonBackColor() : "transparent",
																			borderWidth: isDeliveryFlag ? "0 0 3px 0" : "0",
																			borderStyle: "solid",
																			// backgroundColor: isDeliveryFlag ? setMobileCardColor() : setMobileBackColor(),
																			color: isDeliveryFlag ? setMobileButttonBackColor() : setMobileTextColor(),
																			textAlign: "center",
																		}}
																	>
																		{t("Delivery")}
																	</div>
																)}
																{allTreeData?.details?.is_pickup_active && (
																	<div
																		style={{
																			// flex: 1,
																			padding: isDesktop ? "16px 24px" : "14px 24px",
																			border: "none",
																			fontSize: "16px",
																			fontWeight: 600,
																			borderRight: allTreeData?.details?.is_delivery_active ? `1px solid ${setMobileCardBorderColor()}` : "none",
																			borderColor: isPickupFlag ? setMobileButttonBackColor() : "transparent",
																			borderWidth: isPickupFlag ? "0 0 3px 0" : "0",
																			borderStyle: "solid",
																			// backgroundColor: isPickupFlag ? setMobileCardColor() : setMobileBackColor(),
																			color: isPickupFlag ? setMobileButttonBackColor() : setMobileTextColor(),
																			textAlign: "center",
																		}}
																	>
																		{t("Pickup")}
																	</div>
																)}


															</>
														)}
													</div>
													{!JSON.parse(params.get("t")) && activeType !== "dinein" && activeType && activeType !== "browse" && (
														<div
															onClick={() => setOrderTypeDialogOpen(true)}
															style={{
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'center',
																cursor: 'pointer',
																marginBottom: '24px',
																padding: '12px 16px',
																backgroundColor: setMobileCardColor(),
																border: `1px solid ${setMobileCardBorderColor()}`,
																borderRadius: '12px',
																gap: '8px',
																transition: 'all 0.2s ease',
															}}
														>
															<Edit fontSize="small" style={{ color: setMobileButttonBackColor() }} />
															<Typography className="sub-font" style={{
																color: setMobileTextColor(),
																fontSize: '14px',
																fontWeight: 600
															}}>
																{getOrderTypeDisplayText(activeType)}
															</Typography>
														</div>
													)}

													{/* Show selection prompt if in browse mode */}
													{activeType === "browse" && (
														<div
															onClick={() => setOrderTypeDialogOpen(true)}
															style={{
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'center',
																cursor: 'pointer',
																marginBottom: '24px',
																padding: '16px',
																backgroundColor: setMobileButttonBackColor() + '10',
																border: `2px dashed ${setMobileButttonBackColor()}`,
																borderRadius: '12px',
																gap: '8px',
																transition: 'all 0.2s ease',
															}}
														>
															<Edit fontSize="small" style={{ color: setMobileButttonBackColor() }} />
															<Typography className="sub-font" style={{
																color: setMobileButttonBackColor(),
																fontSize: '14px',
																fontWeight: 600,
																textAlign: 'center'
															}}>
																{t("Select Order Type to Continue")}
															</Typography>
														</div>
													)}




													{/* Pickup Venue Section */}
													{isPickupFlag && allTreeData?.details?.is_pickup_active && allTreeData?.details?.pickup_venues?.length > 0 && (
														<div
															className="m-top-12 p-24 rounded-3 sub-font"
															style={{
																color: setMobileTextColor(),
																border: `1px solid ${setMobileCardBorderColor()}`,
																backgroundColor: setMobileCardColor(),
																padding: "24px",
																borderRadius: "12px",
																boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
																marginBottom: "16px",
															}}
														>
															<TextField
																select
																id="pickupVenue"
																name="pickupVenue"
																label={
																	<span className="sub-font">
																		{allTreeData.details.pickup_venues.length === 1
																			? t("Pickup Venue")
																			: t("Select Pickup Venue")}
																	</span>
																}
																required={isPickupFlag}
																value={
																	allTreeData.details.pickup_venues.length === 1
																		? allTreeData.details.pickup_venues[0]?.id
																		: values.pickupVenue
																}
																onChange={(e) => setFieldValue("pickupVenue", e.target.value)}
																className="rounded-2 sub-font"
																size="small"
																sx={{
																	backgroundColor: setMobileCardColor(),
																	minWidth: 300,
																	marginTop: "12px",
																	"& .MuiOutlinedInput-root": { borderRadius: "8px" },
																	"& .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileCardBorderColor(),
																	},
																	"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileButttonBackColor(),
																	},
																	"& .MuiInputBase-input": {
																		color: setMobileTextColor() || "#333",
																		fontFamily:
																			["ar", "fa"].includes(getLocalStorageMenuItem("lang"))
																				? "Almarai"
																				: "Roboto, sans-serif",
																		fontWeight: 500,
																		letterSpacing: "0.5px",
																	},
																	"& .MuiInputLabel-root": {
																		color: setMobileTextColor() || "#555",
																		fontWeight: 500,
																	},
																	"& .MuiInputLabel-root.Mui-focused": {
																		color: setMobileButttonBackColor(),
																	},
																	// Add these styles for the dropdown menu
																	"& .MuiMenu-paper": {
																		backgroundColor: setMobileCardColor(), // Background of dropdown
																		borderRadius: "8px",
																		boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
																	},
																	"& .MuiMenu-list": {
																		padding: 0,
																	},
																}}
																SelectProps={{
																	MenuProps: {
																		sx: {
																			"& .MuiPaper-root": {
																				backgroundColor: setMobileCardColor(), // Dropdown background
																				borderRadius: "8px",
																				boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
																				"& .MuiMenuItem-root": {
																					backgroundColor: setMobileCardColor(), // Menu item background
																					color: setMobileTextColor() || "#333",
																					fontFamily: ["ar", "fa"].includes(getLocalStorageMenuItem("lang"))
																						? "Almarai"
																						: "Roboto, sans-serif",
																					fontWeight: 500,
																					"&:hover": {
																						backgroundColor: setMobileButttonBackColor() + "20",
																					},
																					"&.Mui-selected": {
																						backgroundColor: setMobileButttonBackColor() + "40",
																						"&:hover": {
																							backgroundColor: setMobileButttonBackColor() + "60",
																						},
																					},
																				},
																			},
																		},
																	},
																}}
															>
																{allTreeData.details.pickup_venues.map((venue) => (
																	<MenuItem
																		className="sub-font"
																		key={venue.id}
																		value={venue.id}
																		sx={{
																			backgroundColor: "transparent", // This will be overridden by MenuProps
																			color: setMobileTextColor() || "#333",
																			fontFamily:
																				["ar", "fa"].includes(getLocalStorageMenuItem("lang"))
																					? "Almarai"
																					: "Roboto, sans-serif",
																			fontWeight: 500,
																		}}
																	>
																		{venue.name}
																	</MenuItem>
																))}
															</TextField>
														</div>
													)}


													{/* Delivery Address Section */}
													{isDeliveryFlag && (
														<>
															<div
																className="m-top-12 p-24 rounded-3 alignByLang sub-font"
																style={{
																	border: `1px solid ${setMobileCardBorderColor()}`,
																	backgroundColor: setMobileCardColor(),
																	borderRadius: "12px",
																	boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
																	marginBottom: "16px",
																}}
																ref={divRef}

																onClick={() => {
																	if (!check_login) {
																		handleOpenDialog(0);

																	} else {
																		setDeliveryDialogOpen(true);
																	}
																}}
																sx={{
																	mt: 2,
																	mb: 2,
																	ml: 2,
																	px: 2,
																	py: 1,
																	display: "flex",
																	alignItems: "center",
																	backgroundColor: setMobileButttonBackColor() + '10',
																	borderRadius: "12px",
																	cursor: "pointer",
																	border: `1px solid ${setMobileCardBorderColor()}`,
																	transition: "all 0.2s ease",
																	'&:hover': {
																		backgroundColor: setMobileButttonBackColor() + '20',
																	}
																}}
															>

																<div style={{ flex: 1, display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 5 }} className="alignByLang">

																	<Typography
																		variant="body2"
																		className="sub-font"
																		sx={{
																			color: setMobileTextColor(),
																			overflow: "hidden",
																			textOverflow: "ellipsis",
																			whiteSpace: "nowrap",
																			fontWeight: 500,
																			fontSize: 20
																		}}
																	>
																		<EditLocationAltOutlined
																			sx={{
																				mr: 1,
																				color: setMobileButttonBackColor(),
																			}}
																			fontSize="medium"
																		/>
																		{selectedPlace?.title || t("Select Delivery Location")}

																	</Typography>
																</div>

																<Typography
																	variant="body2"
																	className="sub-font alignByLang"
																	sx={{
																		color: setMobileTextColor(),
																		overflow: "hidden",
																		textOverflow: "ellipsis",
																		fontWeight: 500,
																		fontSize: 16,
																		textWrap: "wrap",
																		direction: getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fa" ? 'rtl' : 'ltr'
																	}}
																>
																	{placeAddress || ""}

																</Typography>

															</div>

															{selectedPlace && allTreeData?.details?.venue_latitude && allTreeData?.details?.venue_longitude && (
																<VenueToLocationMap
																	venueLocation={{
																		lat: parseFloat(allTreeData.details.venue_latitude),
																		lng: parseFloat(allTreeData.details.venue_longitude)
																	}}
																	selectedLocation={selectedPlace}
																/>
															)}
															<input hidden={true} name="address_id" id="address_id" value={selectedPlace?.id || ""} className="m-top-12 p-24 rounded-3" />
														</>
													)}



													{/* Order Details Section */}
													<div
														className="m-top-12  rounded-3"
														style={{
															border: `1px solid ${setMobileCardBorderColor()}`,
															backgroundColor: setMobileCardColor(),
															borderRadius: "12px",
															boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
															marginBottom: "16px",
															padding: "12px"
														}}
													>
														<div className="d-flex justify-content-between align-items-center mb-3">
															<label
																className="font-size-14 mb-0 head-font"
																style={{
																	color: setMobileTextColor(),
																	display: "flex",
																	alignItems: "center",
																	fontWeight: 600,
																}}
															>
																<DescriptionOutlined
																	className={`${getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fa" ? "ms-2" : "me-2"}`}
																	style={{
																		color: setMobileButttonBackColor(),
																	}}
																	fontSize="medium"
																/>
																{t("Order details")}
															</label>

															<Button
																onClick={() => setConfirmEmptyDialog(true)}
																style={{
																	color: setMobileTextColor(),
																	backgroundColor: "rgba(211, 47, 47, 0.04)",
																	fontWeight: 600,
																	fontSize: "12px",
																	letterSpacing: "0.2px",
																	border: `1px solid ${setMobileTextColor()}`,
																	borderRadius: "6px",
																	padding: "6px 12px",
																	textTransform: "none",
																	minWidth: "auto",
																	transition: "all 0.2s ease-in-out",
																}}
																startIcon={<DeleteOutline sx={{ fontSize: "16px" }} />}
																className="head-font"
															>
																{t("Empty Cart")}
															</Button>
														</div>
														{groupOrdersWithOptions(values?.items)?.map((order) => (
															<Order
																key={order.index}
																order={order}
																handleOpenToast={handleOpenToast}
																currency={currencySymbol}
																tableQr={tableQr}
																tableName={tableName}
																refetch={refetchBasket}
																ordersLength={values?.items?.length || 0}
																isDesktop={isDesktop}
															/>
														))}
													</div>

													{/* Coupon Section */}
													<div
														className="m-top-12 p-24 rounded-3"
														style={{
															border: `1px solid ${setMobileCardBorderColor()}`,
															backgroundColor: setMobileCardColor(),
															borderRadius: "12px",
															boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
															marginBottom: "16px",
														}}
													>
														<label
															className="font-size-14 mb-1 sub-font"
															style={{
																color: setMobileTextColor(),
																display: "flex",
																alignItems: "center",
																fontWeight: 500,
															}}
														>
															<LocalOfferOutlined
																className={`${getLocalStorageMenuItem("lang") === "ar" ||
																	getLocalStorageMenuItem("lang") === "fa"
																	? "ms-2"
																	: "me-2"
																	}`}
																style={{
																	color: setMobileButttonBackColor(),
																}}
																fontSize="large"
															/>
															{t("Coupon Code")}
														</label>


														<div style={{ marginTop: "12px", display: "flex", gap: "12px" }}>
															<TextField
																value={couponCode}
																onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
																placeholder={t("Enter coupon code")}
																size="small"
																sx={{
																	flex: 1,
																	backgroundColor: setMobileCardColor(),
																	"& .MuiOutlinedInput-root": {
																		borderRadius: "8px",
																	},
																	"& .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileCardBorderColor(),
																	},
																	"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileButttonBackColor(),
																	},
																	"& .MuiInputBase-input": {
																		color: setMobileTextColor(),
																		fontFamily:
																			getLocalStorageMenuItem("lang") === "ar" ||
																				getLocalStorageMenuItem("lang") === "fa"
																				? "Almarai"
																				: "Roboto",
																	},
																}}
															/>
															<LoadingButton
																loading={couponLoading}
																onClick={handleApplyCoupon}
																variant="contained"
																size="small"
																sx={{
																	backgroundColor: setMobileButttonBackColor(),
																	color: setMobileHighlightTextColor() || setMobileTextColor(),
																	minWidth: "80px",
																	borderRadius: "8px",
																	textTransform: "none",
																	fontFamily:
																		getLocalStorageMenuItem("lang") === "ar" ||
																			getLocalStorageMenuItem("lang") === "fa"
																			? "Almarai"
																			: "Roboto",
																	"&:hover": {
																		backgroundColor: setMobileButttonBackColor() + "CC",
																	},
																	"&.Mui-disabled": {
																		backgroundColor: setMobileCardBorderColor(),
																		color: setMobileTextColor() + "60",
																	},
																}}
															>
																{t("Apply")}
															</LoadingButton>
														</div>

													</div>

													{appliedCoupon && (
														// Show applied coupon details
														<div
															style={{
																marginTop: "12px",
																padding: "16px",
																backgroundColor: setMobileButttonBackColor() + "10",
																borderRadius: "8px",
																border: `1px solid ${setMobileButttonBackColor()}30`,
															}}
														>
															<Typography
																className="sub-font"
																style={{
																	color: setMobileButttonBackColor(),
																	fontWeight: 600,
																	marginBottom: "8px",
																}}
															>
																✓ {t("Coupon Applied Successfully")}
															</Typography>


															<Typography
																className="sub-font"
																style={{
																	color: setMobileButttonBackColor(),
																	fontSize: "16px",
																	fontWeight: 600,
																}}
															>
																{t("Total Discount")}: {appliedCoupon.total_discount}
															</Typography>
														</div>
													)}

													{/* Payment Details Section */}
													<div
														className="m-top-12 p-24 rounded-3"
														style={{
															border: `1px solid ${setMobileCardBorderColor()}`,
															backgroundColor: setMobileCardColor(),
															borderRadius: "12px",
															boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
															marginBottom: "16px",
														}}
													>
														<label
															className="font-size-14 mb-1 sub-font"
															style={{
																color: setMobileTextColor(),
																display: "flex",
																alignItems: "center",
																fontWeight: 500,
															}}
														>
															<DescriptionOutlined
																className={`${getLocalStorageMenuItem("lang") === "ar" ||
																	getLocalStorageMenuItem("lang") === "fa"
																	? "ms-2"
																	: "me-2"
																	}`}
																style={{
																	color: setMobileButttonBackColor(),
																}}
																fontSize="large"
															/>
															{t("Payment details")}
														</label>
														<div className="m-top-12">
															<p
																className="d-flex justify-content-between sub-font"
																style={{
																	color: setMobileTextColor(),
																	margin: "12px 0",
																}}
															>
																<span className="font-size-16">
																	{t("Subtotal")}
																</span>
																<span className="font-size-16">
																	{values.the_sub_total}
																	<span className="font-size-16 mx-2">
																		{currencySymbol === "SAR" ? (
																			<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																		) : (
																			currencySymbol
																		)}
																	</span>
																</span>
															</p>

															{appliedCoupon && values?.the_items_discount > 0 && (
																<p
																	className="d-flex justify-content-between sub-font"
																	style={{
																		color: setMobileButttonBackColor(),
																		margin: "12px 0",
																	}}
																>
																	<span className="font-size-16">
																		{t("Items Discount")}
																	</span>
																	<span className="font-size-16">
																		-{Number(values?.the_items_discount || 0).toFixed(2)}
																		<span className="font-size-16 mx-2">
																			{currencySymbol === "SAR" ? (
																				<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																			) : (
																				currencySymbol
																			)}
																		</span>
																	</span>
																</p>
															)}

															{values?.tax && (
																<p
																	className="d-flex justify-content-between sub-font"
																	style={{
																		color: setMobileTextColor(),
																		margin: "12px 0",
																	}}
																>
																	<span className="font-size-16">{t("Tax")} {" "}({t("15%")})</span>
																	<span className="font-size-16">
																		{values.the_tax}
																		<span className="font-size-16 mx-2">
																			{currencySymbol === "SAR" ? (
																				<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																			) : (
																				currencySymbol
																			)}
																		</span>
																	</span>
																</p>
															)}

															{values?.tax_admin > 0 && (
																<p
																	className="d-flex justify-content-between sub-font"
																	style={{
																		color: setMobileTextColor(),
																		margin: "12px 0",
																	}}
																>
																	<span className="font-size-16">{t("Admin tax")}{" "}({t("15%")})</span>
																	<span className="font-size-16">
																		{values?.tax_admin}
																		<span className="font-size-16 mx-2">
																			{currencySymbol === "SAR" ? (
																				<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																			) : (
																				currencySymbol
																			)}
																		</span>
																	</span>
																</p>
															)}
															<p style={{ borderTop: `1px solid ${setMobileCardBorderColor()}`, margin: "1px 0", paddingTop: "1px" }}></p>


															<p
																className="d-flex justify-content-between head-font"
																style={{
																	color: setMobileTextColor(),
																	margin: "12px 0",
																}}
															>
																<span className="font-size-18" style={{ fontWeight: 600 }}>{t("Total")}</span>
																<span className="font-size-18" style={{
																	color: setMobileButttonBackColor(),
																	fontWeight: 600,
																}}>

																	{Number(values?.the_total || 0).toFixed(2) || 0}
																	<span className="font-size-18 mx-2">
																		{currencySymbol === "SAR" ? (
																			<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																		) : (
																			currencySymbol
																		)}
																	</span>
																</span>
															</p>


															{isDeliveryFlag && allTreeData?.details?.is_delivery_active && (
																<p
																	className="d-flex justify-content-between sub-font"
																	style={{
																		color: setMobileTextColor(),
																		margin: "12px 0",
																	}}
																>
																	<span className="font-size-16">
																		{t("Delivery Amount")}
																	</span>
																	<span className="font-size-16">
																		{Number(values?.the_delivery_amount || 0)}
																		<span className="font-size-16 mx-2">
																			{currencySymbol === "SAR" ? (
																				<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																			) : (
																				currencySymbol
																			)}
																		</span>
																	</span>
																</p>

															)}

															{appliedCoupon && values?.the_delivery_discount > 0 && (
																<p
																	className="d-flex justify-content-between sub-font"
																	style={{
																		color: setMobileButttonBackColor(),
																		margin: "12px 0",
																	}}
																>
																	<span className="font-size-16">
																		{t("Delivery Discount")}
																	</span>
																	<span className="font-size-16">
																		-{Number(values?.the_delivery_discount || 0).toFixed(2)}
																		<span className="font-size-16 mx-2">
																			{currencySymbol === "SAR" ? (
																				<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																			) : (
																				currencySymbol
																			)}
																		</span>
																	</span>
																</p>
															)}

															{isDeliveryFlag && allTreeData?.details?.is_delivery_active && (
																<p
																	className="d-flex justify-content-between sub-font"
																	style={{
																		color: setMobileTextColor(),
																		margin: "12px 0",
																	}}
																>
																	<span className="font-size-16">
																		{t("Delivery Tax")}{" "}({t("15%")})
																	</span>
																	<span className="font-size-16">
																		{Number(values?.the_delivery_tax || 0)}
																		<span className="font-size-16 mx-2">
																			{currencySymbol === "SAR" ? (
																				<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																			) : (
																				currencySymbol
																			)}
																		</span>
																	</span>
																</p>

															)}
														</div>
														<div style={{ borderTop: `1px solid ${setMobileCardBorderColor()}`, margin: "16px 0", paddingTop: "16px" }}>
															<p
																className="d-flex justify-content-between head-font"
																style={{
																	color: setMobileTextColor(),
																	margin: "12px 0",
																}}
															>
																<span className="font-size-18" style={{ fontWeight: 600 }}>{t("End Total")}</span>
																<span className="font-size-18" style={{
																	color: setMobileButttonBackColor(),
																	fontWeight: 600,
																}}>

																	{Number(values?.the_final_total || 0).toFixed(2)}
																	<span className="font-size-18 mx-2">
																		{currencySymbol === "SAR" ? (
																			<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																		) : (
																			currencySymbol
																		)}
																	</span>
																</span>
															</p>
															<p
																className="d-flex alignByLang sub-font"
																style={{
																	color: setMobileTextColor(),
																	opacity: 0.8,
																	fontSize: "14px",
																}}
															>
																<span>
																	{t("Total plus VAT")}
																</span>
															</p>
														</div>
													</div>

													{/* Payment Method (SA only) */}
													{/* Payment Method (Mobile) - Updated logic */}
													{allTreeData?.details?.is_online_payment_active || allTreeData?.details?.is_cash_payment_active ? (
														<div
															className="m-top-12 p-24 rounded-3"
															style={{
																border: `1px solid ${setMobileCardBorderColor()}`,
																backgroundColor: setMobileCardColor(),
																borderRadius: "12px",
																boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
																marginBottom: "16px",
															}}
														>
															{customerBalance > 0 && (
																<FormControlLabel
																	control={
																		<Checkbox
																			checked={useWallet}
																			onChange={(e) => setUseWallet(e.target.checked)}
																			sx={{
																				color: setMobileButttonBackColor(),
																				'&.Mui-checked': {
																					color: setMobileButttonBackColor(),
																				},
																			}}
																		/>
																	}
																	label={
																		<Typography className="sub-font" style={{ color: setMobileTextColor() }}>
																			{t("Use Wallet Balance")} ({currencySymbol} {customerBalance.toFixed(2)})
																		</Typography>
																	}
																	sx={{ mb: 2 }}
																/>
															)}

															<FormControl component="fieldset" fullWidth>
																<FormLabel
																	component="legend"
																	className="sub-font"
																	sx={{
																		color: setMobileTextColor(),
																		fontWeight: 600,
																		marginBottom: 2,
																		'&.Mui-focused': {
																			color: setMobileButttonBackColor(),
																		}
																	}}
																>
																	{t("Payment Method")}
																</FormLabel>

																<RadioGroup
																	value={payment_method}
																	onChange={(e) => {
																		setFieldValue("payment_method", e.target.value);
																		setPaymentMethod(e.target.value);
																	}}
																	name="payment_method"
																>
																	{allTreeData?.details?.is_online_payment_active && (
																		isDineInFlag && allTreeData?.details?.is_dinein_active ?
																			allTreeData?.details?.is_dinein_online_payment_active && (
																				<FormControlLabel
																					value="ONL"
																					control={
																						<Radio
																							sx={{
																								color: setMobileButttonBackColor(),
																								'&.Mui-checked': {
																									color: setMobileButttonBackColor(),
																								},
																							}}
																						/>
																					}
																					label={
																						<Typography className="sub-font" style={{ color: setMobileTextColor() }}>
																							{t("PAY ONLINE")}
																						</Typography>
																					}
																					disabled={useWallet && customerBalance >= Number(values.the_final_total?.replace(/,/g, ""))}
																				/>
																			)
																			: (
																				<FormControlLabel
																					value="ONL"
																					control={
																						<Radio
																							sx={{
																								color: setMobileButttonBackColor(),
																								'&.Mui-checked': {
																									color: setMobileButttonBackColor(),
																								},
																							}}
																						/>
																					}
																					label={
																						<Typography className="sub-font" style={{ color: setMobileTextColor() }}>
																							{t("PAY ONLINE")}
																						</Typography>
																					}
																					disabled={useWallet && customerBalance >= Number(values.the_final_total?.replace(/,/g, ""))}
																				/>
																			)
																	)}

																	{allTreeData?.details?.is_cash_payment_active && (
																		<FormControlLabel
																			value="Cash"
																			control={
																				<Radio
																					sx={{
																						color: setMobileButttonBackColor(),
																						'&.Mui-checked': {
																							color: setMobileButttonBackColor(),
																						},
																					}}
																				/>
																			}
																			label={
																				<Typography className="sub-font" style={{ color: setMobileTextColor() }}>
																					{t("Cash")}
																				</Typography>
																			}
																			disabled={useWallet && customerBalance >= Number(values.the_final_total?.replace(/,/g, ""))}
																		/>
																	)}

																	{!allTreeData?.details?.is_online_payment_active && !allTreeData?.details?.is_cash_payment_active && (
																		<Typography className="sub-font" style={{ color: setMobileTextColor(), padding: "8px" }}>
																			{t("No payment methods available")}
																		</Typography>
																	)}
																</RadioGroup>

																{!payment_method && (
																	<Typography
																		className="sub-font"
																		sx={{
																			color: "#f44336",
																			fontSize: "0.75rem",
																			marginTop: 1
																		}}
																	>
																		{t("Please select a payment method")}
																	</Typography>
																)}
															</FormControl>
														</div>
													) : (
														<div
															className="m-top-12 p-24 rounded-3"
															style={{
																border: `1px solid ${setMobileCardBorderColor()}`,
																backgroundColor: setMobileCardColor(),
																borderRadius: "12px",
																boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
																marginBottom: "16px",
																textAlign: "center",
															}}
														>
															<Typography className="sub-font" style={{ color: setMobileTextColor() }}>
																{t("No payment methods available")}
															</Typography>
														</div>
													)}

													{/* Order Notes Section */}
													<div
														className="m-top-12 p-24 rounded-3"
														style={{
															border: `1px solid ${setMobileCardBorderColor()}`,
															backgroundColor: setMobileCardColor(),
															borderRadius: "12px",
															boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
															marginBottom: "70px",
														}}
													>
														<label
															htmlFor="note"
															className="font-size-14 mb-1 sub-font"
															style={{
																color: setMobileTextColor(),
																fontWeight: 500,
															}}
														>
															{t("Note")}
														</label>
														<TextField
															id="note"
															name="note"
															type="note"
															variant="outlined"
															value={orderNote}
															onChange={(e) => {
																setFieldValue("note", e.target.value);
																setOrderNote(e.target.value);
															}}
															placeholder={t("Enter your note")}
															helperText={errors.note && errors.note}
															className="rounded-2 sub-font"
															error={errors.note}
															size="small"
															fullWidth
															multiline
															rows={3}
															sx={{
																backgroundColor: setMobileCardColor(),
																minWidth: 300,
																marginTop: "12px",
																"& .MuiOutlinedInput-root": {
																	borderRadius: "8px",
																},
																"& .MuiOutlinedInput-notchedOutline": {
																	borderColor: setMobileCardBorderColor(),
																},
																"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																	borderColor: setMobileButttonBackColor(),
																},
																"& .MuiInputBase-input": {
																	color: setMobileTextColor(),
																	fontFamily:
																		getLocalStorageMenuItem("lang") === "ar" ||
																			getLocalStorageMenuItem("lang") === "fa"
																			? "Almarai"
																			: "Roboto",
																},
																"& .MuiInputLabel-root": {
																	color: setMobileTextColor(),
																},
																"& .MuiFormHelperText-root": {
																	color: "#f44336",
																},
															}}
														/>
													</div>

													{/* Submit Button */}
													{(!allTreeData?.details?.order_ability && !allTreeData?.details?.whatsapp) || (values?.length === 0 || basketData?.data?.data?.length === 0) ? null : (
														<div
															className="mt-2 send-order text-center btn d-block"
															style={{
																backgroundColor: setMobileButttonBackColor(),
																color: setMobileTextColor(),
																width: divWidth,
																borderRadius: "12px",
																padding: "5px",
																boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
																zIndex: 100,
															}}
														>
															{isLoadingOrder ? (
																<Button
																	className="button-height-sm head-font"
																	variant="text"
																	fullWidth={true}
																	style={{
																		backgroundColor: "transparent",
																		color: setMobileHighlightTextColor() || setMobileTextColor(),
																	}}
																>
																	<CircularProgress
																		style={{ color: setMobileHighlightTextColor() || setMobileTextColor() }}
																		className="mx-2"
																		size={24}
																	/>{" "}
																	<span>{t("Loading...")}</span>
																</Button>
															) : (
																<Button
																	className="w-100 head-font"
																	type="submit"
																	disabled={allTreeData?.details?.is_online_payment_active === false && allTreeData?.details?.is_cash_payment_active === false}
																	style={{
																		color: setMobileHighlightTextColor() || setMobileTextColor(),
																		fontWeight: 600,
																		fontSize: "16px",
																		letterSpacing: "0.5px",
																		'&:hover': {
																			backgroundColor: setMobileButttonBackColor() + 'CC',
																		}
																	}}
																>
																	{t("confirm order")}
																</Button>
															)}
														</div>
													)}
												</Form>
											)}
										</Formik>
									</div>
								</div>
							</div>
						</div>
					)}



					<Toast
						open={toastSettings.open}
						message={toastSettings.message}
						resetToast={handleCloseToast}
						success={toastSettings.success}
					/>
				</div>

				<LoadingTreeDataDialog
					openTreeDialogFlag={loadingTreeDialog}
					onClose={() => setLoadingTreeDialog(false)}
					tableName={tableName}
					tableQr={tableQr}
					from_home={false}
				/>

				<Dialog
					className="alignByLang"
					fullWidth
					open={openDialog}
					onClose={closePaymentDialog}
				>
					<DialogTitle className="head-font">{t("Payment Method")}</DialogTitle>
					<DialogContent>
						<FormControl fullWidth>
							<InputLabel className="sub-font" style={{ marginTop: 5 }}>
								{t("Payment Method")}
							</InputLabel>
							<Select
								value={selectedGateway}
								onChange={handleGatewaySelect}
								label={t("Payment Method")}
							>
								<MenuItem className="sub-font" value="mada">{t("mada")}</MenuItem>
							</Select>
						</FormControl>

						{selectedGateway && (
							<div style={{ marginTop: "20px", textAlign: "center" }}>
								<img
									src={gatewayImage}
									alt="Gateway"

									style={{ width: "auto", height: "auto", maxWidth: "100%", maxHeight: "200px", objectFit: "contain" }}
								/>
							</div>
						)}
					</DialogContent>

					<DialogActions>
						<Button className="head-font" onClick={closePaymentDialog} color="secondary">
							{t("Cancel")}
						</Button>
						<Button
							className="head-font"
							onClick={handlePayment}
							color="primary"
							disabled={!selectedGateway}
						>
							{t("Continue")}
						</Button>
					</DialogActions>
				</Dialog>

				<LoginComponent
					open={dialogOpen}
					handleCloseDialog={handleCloseDialog}
					tableQr={tableQr}
					tableName={tableName}
					onVerificationSuccess={handleVerificationSuccess}
					is_from={3}
				/>

				<DeliveryDialog
					open={deliveryDialogOpen}
					savedPlaces={savedPlaces}
					isLoadingSavedPlaces={isLoadingSavedPlaces}
					openLocationFormDailog={() => setOpenLocationFormDialog(true)}
					onClose={() => setDeliveryDialogOpen(false)}
					onSelect={handleOptionSelect}
					onSelectPlace={handleSelectPlace}
					openDeleteLocationDialog={handleOpenDeleteLocationDialog}
				/>


				<CurrentLocationDialog
					open={mode === "current"}
					onClose={() => setMode(null)}
					setLatLangVal={setLatLangVal}
					updateLocationFormData={updateLocationFormData}
					setMobileBackColor={setMobileBackColor}
					setMobileTextColor={setMobileTextColor}
					setMobileCardBorderColor={setMobileCardBorderColor}
				/>


				<NewLocationDialog
					open={mode === "new"}
					onClose={() => setMode(null)}
					openLocationFormDailog={() => setOpenLocationFormDialog(true)}
					closeLocationFormDailog={() => handleCloseFormDialog()}
					setLatLangVal={setLatLangVal}
					closeMapModal={() => setMode(null)}
					updateLocationFormData={(pickupMapAddress) => updateLocationFormData(pickupMapAddress)}
					setMobileBackColor={setMobileBackColor}
					setMobileTextColor={setMobileTextColor}
					setMobileCardBorderColor={setMobileCardBorderColor}
				/>

				<LocationFormDialog
					open={openLocationFormDialog}
					onClose={handleCloseFormDialog}
					isEditDelivery={isEditDelivery}
					isProcessLoading={isProcessLoading}
					locationFormData={locationFormData}
					handleLocationFormInputChange={handleLocationFormInputChange}
					handleSaveLocation={handleSaveLocation}
					handleUpdateLocation={handleUpdateLocation}
					setMobileBackColor={setMobileBackColor}
					setMobileTextColor={setMobileTextColor}
					setMobileCardBorderColor={setMobileCardBorderColor}
					setMobileCardColor={setMobileCardColor}
					setMobileButttonBackColor={setMobileButttonBackColor}
				/>

				{/* Empty Cart Confirmation Dialog */}
				<Dialog
					open={confirmEmptyDialog}
					onClose={() => setConfirmEmptyDialog(false)}
					PaperProps={{
						sx: {
							backgroundColor: setMobileCardColor(),
							color: setMobileTextColor(),
							borderRadius: "12px",
							padding: "16px",
							minWidth: "300px"
						}
					}}
				>
					<DialogTitle className="head-font" sx={{ textAlign: "center" }}>
						{t("Empty Cart?")}
					</DialogTitle>
					<DialogContent>
						<Typography className="sub-font" sx={{ textAlign: "center" }}>
							{t("Are you sure you want to remove all items from your cart?")}
						</Typography>
					</DialogContent>
					<DialogActions sx={{ justifyContent: "center", gap: 2, paddingBottom: "16px" }}>
						<Button
							onClick={() => setConfirmEmptyDialog(false)}
							sx={{
								color: setMobileTextColor(),
								border: `1px solid ${setMobileCardBorderColor()}`,
								borderRadius: "8px",
								padding: "8px 16px",
								textTransform: "none",
								minWidth: "100px"
							}}
						>
							{t("Cancel")}
						</Button>
						<Button
							onClick={() => {
								emptyOrderBasket().then(() => {
									handleOpenToast(t("Cart has been emptied"), true);
									handleBack();
								});

								setConfirmEmptyDialog(false);
							}}
							sx={{
								backgroundColor: "#f44336",
								color: "white",
								borderRadius: "8px",
								padding: "8px 16px",
								textTransform: "none",
								minWidth: "100px",
								'&:hover': {
									backgroundColor: "#d32f2f"
								}
							}}
						>
							{t("Empty")}
						</Button>
					</DialogActions>
				</Dialog>

				<DeleteLocationDialog
					onDeleteDeleteLocationDialog={handleDeleteLocation}
					deleteLocationDialogOpen={deleteLocationDialogOpen}
					onCloseDeleteLocationDialog={() => setDeleteLocationDialogOpen(false)}
				/>

				<LocationDistanceDialog
					open={locationDistanceDialogOpen}
					onClose={handleLocationDistanceCancel}
					onChangeAddresss={() => setDeliveryDialogOpen(true)}
					onConfirm={handleLocationDistanceConfirm}
					onCancel={handleLocationDistanceCancel}
				/>

				{/* Order Type Selection Dialog */}
				{/* Order Type Selection Dialog */}
				<Formik
					onSubmit={handleSubmit}
					initialValues={basketData?.data.data || {}}
					enableReinitialize
					key={activeType}
				>
					{({ setFieldValue }) => (
						<Dialog
							open={orderTypeDialogOpen}
							onClose={() => setOrderTypeDialogOpen(false)}
							PaperProps={{
								style: {
									backgroundColor: setMobileBackColor(),
									color: setMobileTextColor(),
									borderRadius: '12px',
									padding: '16px',
								},
							}}
						>
							<DialogTitle style={{ textAlign: 'center', padding: '16px' }}>
								<Typography variant="h5" className="head-font" style={{ fontWeight: 'bold' }}>
									{t("Select Order Type")}
								</Typography>
							</DialogTitle>
							<DialogContent style={{ padding: '20px' }}>
								<div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
									{allTreeData?.details?.is_delivery_active ? (
										<Button
											className="head-font"
											variant="outlined"
											onClick={() => handleOrderTypeSelection("delivery", setFieldValue)}
											style={{
												padding: '12px',
												borderRadius: '8px',
												borderColor: setMobileCardBorderColor(),
												color: setMobileTextColor(),
												justifyContent: 'flex-start',
												backgroundColor: getLocalStorageMenuItem("orderType") === "delivery" ?
													setMobileButttonBackColor() + '40' : 'transparent',
												fontSize: 18
											}}
											startIcon={<LocalShipping />}
										>
											<div className="alignByLang">
												<div style={{ fontWeight: 'bold' }}>{t("Delivery")}</div>
												<div style={{ fontSize: '0.8rem', opacity: 0.8 }}>
													{t("Get your order completed to your location")}
												</div>
											</div>
										</Button>
									) : ""}



									{allTreeData?.details?.is_pickup_active ? (
										<Button
											className="head-font"
											variant="outlined"
											onClick={() => handleOrderTypeSelection("pickup", setFieldValue)}
											style={{
												padding: '12px',
												borderRadius: '8px',
												borderColor: setMobileCardBorderColor(),
												color: setMobileTextColor(),
												justifyContent: 'flex-start',
												backgroundColor: getLocalStorageMenuItem("orderType") === "pickup" ?
													setMobileButttonBackColor() + '40' : 'transparent',
												fontSize: 18
											}}
											startIcon={<LocalDining />}
										>
											<div className="alignByLang">
												<div style={{ fontWeight: 'bold' }}>{t("Pickup")}</div>
												<div style={{ fontSize: '0.8rem', opacity: 0.8 }}>
													{t("Order online and pick up at the venue")}
												</div>
											</div>
										</Button>
									) : ""}

									{allTreeData?.details?.is_dinein_active && params.get("t") && params.get("t") !== "null" ? (
										<Button
											className="head-font"
											variant="outlined"
											onClick={() => handleOrderTypeSelection("dinein", setFieldValue)}
											style={{
												padding: '12px',
												borderRadius: '8px',
												borderColor: setMobileCardBorderColor(),
												color: setMobileTextColor(),
												justifyContent: 'flex-start',
												backgroundColor: getLocalStorageMenuItem("orderType") === "dinein" ?
													setMobileButttonBackColor() + '40' : 'transparent',
												fontSize: 18
											}}
											startIcon={<Restaurant />}
										>
											<div className="alignByLang">
												<div style={{ fontWeight: 'bold' }}>{t("Dine In")}</div>
												<div style={{ fontSize: '0.8rem', opacity: 0.8 }}>
													{t("Enjoy your meal at our venue")}
												</div>
											</div>
										</Button>
									) : ""}
								</div>
							</DialogContent>
							<DialogActions style={{ padding: '16px', justifyContent: 'center' }}>
								<Button
									className="head-font"
									onClick={() => setOrderTypeDialogOpen(false)}
									style={{
										color: setMobileTextColor(),
										borderColor: setMobileCardBorderColor(),
										borderRadius: '8px',
										padding: '8px 24px',
										fontSize: 18
									}}
									variant="outlined"
								>
									{t("Cancel")}
								</Button>
							</DialogActions>
						</Dialog>
					)}
				</Formik>
				<Dialog
					open={openPaymobDialog}
					onClose={() => setOpenPaymobDialog(false)}
					maxWidth="sm"
					fullWidth
				>
					<DialogTitle sx={{ textAlign: "center", fontWeight: 600 }}>
						Complete Payment
					</DialogTitle>

					<DialogContent>
						<Box
							id="paymob-pixel-container"
							sx={{
								width: "100%",
								minHeight: 420,
								border: "1px solid #ddd",
								borderRadius: 2,
								backgroundColor: "#fff",
							}}
						/>
					</DialogContent>
				</Dialog>

			</Container>
			<BottomNavBar qr={tableQr} qrName={tableName} saveCartState={() => handleSaveCartState()} />
		</div>
	);
};

export default Cart;

